(function(){
    var GravityRD = {};
    var TrimPath = {};

    window.TEST = window.TEST || false;

    // include ext
    if (typeof Object.assign !== 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, "assign", {
        value: function assign(target, varArgs) { // .length of function is 2
            'use strict';
            if (target === null || target === undefined) {
                throw new TypeError('Cannot convert undefined or null to object');
            }

            var to = Object(target);

            for (var index = 1; index < arguments.length; index++) {
                var nextSource = arguments[index];

                if (nextSource !== null && nextSource !== undefined) {
                    for (var nextKey in nextSource) {
                        // Avoid bugs when hasOwnProperty is shadowed
                        if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                            to[nextKey] = nextSource[nextKey];
                        }
                    }
                }
            }
            return to;
        },
        writable: true,
        configurable: true
    });
}/**
 * TrimPath Template. Release 1.1.2.
 * Copyright (C) 2004 - 2007 TrimPath.
 * 
 * TrimPath Template is licensed under the GNU General Public License
 * and the Apache License, Version 2.0, as follows:
 *
 * This program is free software; you can redistribute it and/or 
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; either version 2
 * of the License, or (at your option) any later version.
 * 
 * This program is distributed WITHOUT ANY WARRANTY; without even the 
 * implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  
 * See the GNU General Public License for more details.
 * 
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 59 Temple Place - Suite 330, Boston, MA 02111-1307, USA.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * 
 * http://www.apache.org/licenses/LICENSE-2.0
 * 
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
if (typeof(TrimPath) == 'undefined')
    TrimPath = {};

// TODO: Debugging mode vs stop-on-error mode - runtime flag.
// TODO: Handle || (or) characters and backslashes.
// TODO: Add more modifiers.

(function() {               // Using a closure to keep global namespace clean.
    if (TrimPath.evalEx == null)
        TrimPath.evalEx = function(src) { return eval(src); };

    var UNDEFINED;
    if (Array.prototype.pop == null)  // IE 5.x fix from Igor Poteryaev.
        Array.prototype.pop = function() {
            if (this.length === 0) {return UNDEFINED;}
            return this[--this.length];
        };
    if (Array.prototype.push == null) // IE 5.x fix from Igor Poteryaev.
        Array.prototype.push = function() {
            for (var i = 0; i < arguments.length; ++i) {this[this.length] = arguments[i];}
            return this.length;
        };

    TrimPath.parseTemplate = function(tmplContent, optTmplName, optEtc) {
        if (optEtc == null)
            optEtc = TrimPath.parseTemplate_etc;
        var funcSrc = parse(tmplContent, optTmplName, optEtc);
        var func = TrimPath.evalEx(funcSrc, optTmplName, 1);
        if (func != null)
            return new optEtc.Template(optTmplName, tmplContent, funcSrc, func, optEtc);
        return null;
    }
    
    var exceptionDetails = function(e) {
        return (e.toString()) + ";\n " +
               (e.message) + ";\n " + 
               (e.name) + ";\n " + 
               (e.stack       || 'no stack trace') + ";\n " +
               (e.description || 'no further description') + ";\n " +
               (e.fileName    || 'no file name') + ";\n " +
               (e.lineNumber  || 'no line number');
    }

    try {
        String.prototype.process = function(context, optFlags) {
            var template = TrimPath.parseTemplate(this, null);
            if (template != null)
                return template.process(context, optFlags);
            return this;
        }
    } catch (e) { // Swallow exception, such as when String.prototype is sealed.
    }
    
    TrimPath.parseTemplate_etc = {};            // Exposed for extensibility.
    TrimPath.parseTemplate_etc.statementTag = "forelse|for|if|elseif|else|var|macro";
    TrimPath.parseTemplate_etc.statementDef = { // Lookup table for statement tags.
        "if"     : { delta:  1, prefix: "if (", suffix: ") {", paramMin: 1 },
        "else"   : { delta:  0, prefix: "} else {" },
        "elseif" : { delta:  0, prefix: "} else if (", suffix: ") {", paramDefault: "true" },
        "/if"    : { delta: -1, prefix: "}" },
        "for"    : { delta:  1, paramMin: 3, 
                     prefixFunc : function(stmtParts, state, tmplName, etc) {
                        if (stmtParts[2] != "in")
                            throw new etc.ParseError(tmplName, state.line, "bad for loop statement: " + stmtParts.join(' '));
                        var iterVar = stmtParts[1];
                        var listVar = "__LIST__" + iterVar;
                        return [ "var ", listVar, " = ", stmtParts[3], ";",
                             // Fix from Ross Shaull for hash looping, make sure that we have an array of loop lengths to treat like a stack.
                             "var __LENGTH_STACK__;",
                             "if (typeof(__LENGTH_STACK__) == 'undefined' || !__LENGTH_STACK__.length) __LENGTH_STACK__ = new Array();", 
                             "__LENGTH_STACK__[__LENGTH_STACK__.length] = 0;", // Push a new for-loop onto the stack of loop lengths.
                             "if ((", listVar, ") != null) { ",
                             "var ", iterVar, "_ct = 0;",       // iterVar_ct variable, added by B. Bittman     
                             "for (var ", iterVar, "_index in ", listVar, ") { ",
                             iterVar, "_ct++;",
                             "if (typeof(", listVar, "[", iterVar, "_index]) == 'function') {continue;}", // IE 5.x fix from Igor Poteryaev.
                             "__LENGTH_STACK__[__LENGTH_STACK__.length - 1]++;",
                             "var ", iterVar, " = ", listVar, "[", iterVar, "_index];" ].join("");
                     } },
        "forelse" : { delta:  0, prefix: "} } if (__LENGTH_STACK__[__LENGTH_STACK__.length - 1] == 0) { if (", suffix: ") {", paramDefault: "true" },
        "/for"    : { delta: -1, prefix: "} }; delete __LENGTH_STACK__[__LENGTH_STACK__.length - 1];" }, // Remove the just-finished for-loop from the stack of loop lengths.
        "var"     : { delta:  0, prefix: "var ", suffix: ";" },
        "macro"   : { delta:  1, 
                      prefixFunc : function(stmtParts, state, tmplName, etc) {
                          var macroName = stmtParts[1].split('(')[0];
                          return [ "var ", macroName, " = function", 
                                   stmtParts.slice(1).join(' ').substring(macroName.length),
                                   "{ var _OUT_arr = []; var _OUT = { write: function(m) { if (m) _OUT_arr.push(m); } }; " ].join('');
                     } }, 
        "/macro"  : { delta: -1, prefix: " return _OUT_arr.join(''); };" }
    }
    TrimPath.parseTemplate_etc.modifierDef = {
        "eat"        : function(v)    { return ""; },
        "escape"     : function(s)    { return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"); },
        "capitalize" : function(s)    { return String(s).toUpperCase(); },
        "default"    : function(s, d) { return s != null ? s : d; }
    }
    TrimPath.parseTemplate_etc.modifierDef.h = TrimPath.parseTemplate_etc.modifierDef.escape;

    TrimPath.parseTemplate_etc.Template = function(tmplName, tmplContent, funcSrc, func, etc) {
        this.process = function(context, flags) {
            if (context == null)
                context = {};
            if (context._MODIFIERS == null)
                context._MODIFIERS = {};
            if (context.defined == null)
                context.defined = function(str) { return (context[str] != undefined); };
            for (var k in etc.modifierDef) {
                if (context._MODIFIERS[k] == null)
                    context._MODIFIERS[k] = etc.modifierDef[k];
            }
            if (flags == null)
                flags = {};
            var resultArr = [];
            var resultOut = { write: function(m) { resultArr.push(m); } };
            try {
                func(resultOut, context, flags);
            } catch (e) {
                if (flags.throwExceptions == true)
                    throw e;
                var result = new String(resultArr.join("") + 
                    "[ERROR: template: <pre>" + exceptionDetails(e) + "</pre>]");
                result["exception"] = e;
                return result;
            }
            return resultArr.join("");
        }
        this.name       = tmplName;
        this.source     = tmplContent; 
        this.sourceFunc = funcSrc;
        this.toString   = function() { return "TrimPath.Template [" + tmplName + "]"; }
    }
    TrimPath.parseTemplate_etc.ParseError = function(name, line, message) {
        this.name    = name;
        this.line    = line;
        this.message = message;
    }
    TrimPath.parseTemplate_etc.ParseError.prototype.toString = function() { 
        return ("TrimPath template ParseError in " + this.name + ": line " + this.line + ", " + this.message);
    }
    
    var parse = function(body, tmplName, etc) {
        body = cleanWhiteSpace(body);
        var funcText = [ "var TrimPath_Template_TEMP = function(_OUT, _CONTEXT, _FLAGS) { with (_CONTEXT) {" ];
        var state    = { stack: [], line: 1 };                              // TODO: Fix line number counting.
        var endStmtPrev = -1;
        while (endStmtPrev + 1 < body.length) {
            var begStmt = endStmtPrev;
            // Scan until we find some statement markup.
            begStmt = body.indexOf("{", begStmt + 1);
            while (begStmt >= 0) {
                var endStmt = body.indexOf('}', begStmt + 1);
                var stmt = body.substring(begStmt, endStmt);
                var blockrx = stmt.match(/^\{(cdata|minify|eval)/); // From B. Bittman, minify/eval/cdata implementation.
                if (blockrx) {
                    var blockType = blockrx[1]; 
                    var blockMarkerBeg = begStmt + blockType.length + 1;
                    var blockMarkerEnd = body.indexOf('}', blockMarkerBeg);
                    if (blockMarkerEnd >= 0) {
                        var blockMarker;
                        if( blockMarkerEnd - blockMarkerBeg <= 0 ) {
                            blockMarker = "{/" + blockType + "}";
                        } else {
                            blockMarker = body.substring(blockMarkerBeg + 1, blockMarkerEnd);
                        }                        
                        
                        var blockEnd = body.indexOf(blockMarker, blockMarkerEnd + 1);
                        if (blockEnd >= 0) {                            
                            emitSectionText(body.substring(endStmtPrev + 1, begStmt), funcText);
                            
                            var blockText = body.substring(blockMarkerEnd + 1, blockEnd);
                            if (blockType == 'cdata') {
                                emitText(blockText, funcText);
                            } else if (blockType == 'minify') {
                                emitText(scrubWhiteSpace(blockText), funcText);
                            } else if (blockType == 'eval') {
                                if (blockText != null && blockText.length > 0) // From B. Bittman, eval should not execute until process().
                                    funcText.push('_OUT.write( (function() { ' + blockText + ' })() );');
                            }
                            begStmt = endStmtPrev = blockEnd + blockMarker.length - 1;
                        }
                    }                        
                } else if (body.charAt(begStmt - 1) != '$' &&               // Not an expression or backslashed,
                           body.charAt(begStmt - 1) != '\\') {              // so check if it is a statement tag.
                    var offset = (body.charAt(begStmt + 1) == '/' ? 2 : 1); // Close tags offset of 2 skips '/'.
                                                                            // 10 is larger than maximum statement tag length.
                    if (body.substring(begStmt + offset, begStmt + 10 + offset).search(TrimPath.parseTemplate_etc.statementTag) == 0) 
                        break;                                              // Found a match.
                }
                begStmt = body.indexOf("{", begStmt + 1);
            }
            if (begStmt < 0)                              // In "a{for}c", begStmt will be 1.
                break;
            var endStmt = body.indexOf("}", begStmt + 1); // In "a{for}c", endStmt will be 5.
            if (endStmt < 0)
                break;
            emitSectionText(body.substring(endStmtPrev + 1, begStmt), funcText);
            emitStatement(body.substring(begStmt, endStmt + 1), state, funcText, tmplName, etc);
            endStmtPrev = endStmt;
        }
        emitSectionText(body.substring(endStmtPrev + 1), funcText);
        if (state.stack.length != 0)
            throw new etc.ParseError(tmplName, state.line, "unclosed, unmatched statement(s): " + state.stack.join(","));
        funcText.push("}}; TrimPath_Template_TEMP");
        return funcText.join("");
    }
    
    var emitStatement = function(stmtStr, state, funcText, tmplName, etc) {
        var parts = stmtStr.slice(1, -1).split(' ');
        var stmt = etc.statementDef[parts[0]]; // Here, parts[0] == for/if/else/...
        if (stmt == null) {                    // Not a real statement.
            emitSectionText(stmtStr, funcText);
            return;
        }
        if (stmt.delta < 0) {
            if (state.stack.length <= 0)
                throw new etc.ParseError(tmplName, state.line, "close tag does not match any previous statement: " + stmtStr);
            state.stack.pop();
        } 
        if (stmt.delta > 0)
            state.stack.push(stmtStr);

        if (stmt.paramMin != null &&
            stmt.paramMin >= parts.length)
            throw new etc.ParseError(tmplName, state.line, "statement needs more parameters: " + stmtStr);
        if (stmt.prefixFunc != null)
            funcText.push(stmt.prefixFunc(parts, state, tmplName, etc));
        else 
            funcText.push(stmt.prefix);
        if (stmt.suffix != null) {
            if (parts.length <= 1) {
                if (stmt.paramDefault != null)
                    funcText.push(stmt.paramDefault);
            } else {
                for (var i = 1; i < parts.length; i++) {
                    if (i > 1)
                        funcText.push(' ');
                    funcText.push(parts[i]);
                }
            }
            funcText.push(stmt.suffix);
        }
    }

    var emitSectionText = function(text, funcText) {
        if (text.length <= 0)
            return;
        var nlPrefix = 0;               // Index to first non-newline in prefix.
        var nlSuffix = text.length - 1; // Index to first non-space/tab in suffix.
        while (nlPrefix < text.length && (text.charAt(nlPrefix) == '\n'))
            nlPrefix++;
        while (nlSuffix >= 0 && (text.charAt(nlSuffix) == ' ' || text.charAt(nlSuffix) == '\t'))
            nlSuffix--;
        if (nlSuffix < nlPrefix)
            nlSuffix = nlPrefix;
        if (nlPrefix > 0) {
            funcText.push('if (_FLAGS.keepWhitespace == true) _OUT.write("');
            var s = text.substring(0, nlPrefix).replace('\n', '\\n'); // A macro IE fix from BJessen.
            if (s.charAt(s.length - 1) == '\n')
            	s = s.substring(0, s.length - 1);
            funcText.push(s);
            funcText.push('");');
        }
        var lines = text.substring(nlPrefix, nlSuffix + 1).split('\n');
        for (var i = 0; i < lines.length; i++) {
            emitSectionTextLine(lines[i], funcText);
            if (i < lines.length - 1)
                funcText.push('_OUT.write("\\n");\n');
        }
        if (nlSuffix + 1 < text.length) {
            funcText.push('if (_FLAGS.keepWhitespace == true) _OUT.write("');
            var s = text.substring(nlSuffix + 1).replace('\n', '\\n');
            if (s.charAt(s.length - 1) == '\n')
            	s = s.substring(0, s.length - 1);
            funcText.push(s);
            funcText.push('");');
        }
    }
    
    var emitSectionTextLine = function(line, funcText) {
        var endMarkPrev = '}';
        var endExprPrev = -1;
        while (endExprPrev + endMarkPrev.length < line.length) {
            var begMark = "${", endMark = "}";
            var begExpr = line.indexOf(begMark, endExprPrev + endMarkPrev.length); // In "a${b}c", begExpr == 1
            if (begExpr < 0)
                break;
            if (line.charAt(begExpr + 2) == '%') {
                begMark = "${%";
                endMark = "%}";
            }
            var endExpr = line.indexOf(endMark, begExpr + begMark.length);         // In "a${b}c", endExpr == 4;
            if (endExpr < 0)
                break;
            emitText(line.substring(endExprPrev + endMarkPrev.length, begExpr), funcText);                
            // Example: exprs == 'firstName|default:"John Doe"|capitalize'.split('|')
            var exprArr = line.substring(begExpr + begMark.length, endExpr).replace(/\|\|/g, "#@@#").split('|');
            for (var k in exprArr) {
                if (exprArr[k].replace) // IE 5.x fix from Igor Poteryaev.
                    exprArr[k] = exprArr[k].replace(/#@@#/g, '||');
            }
            funcText.push('_OUT.write(');
            emitExpression(exprArr, exprArr.length - 1, funcText); 
            funcText.push(');');
            endExprPrev = endExpr;
            endMarkPrev = endMark;
        }
        emitText(line.substring(endExprPrev + endMarkPrev.length), funcText); 
    }
    
    var emitText = function(text, funcText) {
        if (text == null ||
            text.length <= 0)
            return;
        text = text.replace(/\\/g, '\\\\');
        text = text.replace(/\n/g, '\\n');
        text = text.replace(/"/g,  '\\"');
        funcText.push('_OUT.write("');
        funcText.push(text);
        funcText.push('");');
    }
    
    var emitExpression = function(exprArr, index, funcText) {
        // Ex: foo|a:x|b:y1,y2|c:z1,z2 is emitted as c(b(a(foo,x),y1,y2),z1,z2)
        var expr = exprArr[index]; // Ex: exprArr == [firstName,capitalize,default:"John Doe"]
        if (index <= 0) {          // Ex: expr    == 'default:"John Doe"'
            funcText.push(expr);
            return;
        }
        var parts = expr.split(':');
        funcText.push('_MODIFIERS["');
        funcText.push(parts[0]); // The parts[0] is a modifier function name, like capitalize.
        funcText.push('"](');
        emitExpression(exprArr, index - 1, funcText);
        if (parts.length > 1) {
            funcText.push(',');
            funcText.push(parts[1]);
        }
        funcText.push(')');
    }

    var cleanWhiteSpace = function(result) {
        result = result.replace(/\t/g,   "    ");
        result = result.replace(/\r\n/g, "\n");
        result = result.replace(/\r/g,   "\n");
        result = result.replace(/^(\s*\S*(\s+\S+)*)\s*$/, '$1'); // Right trim by Igor Poteryaev.
        return result;
    }

    var scrubWhiteSpace = function(result) {
        result = result.replace(/^\s+/g,   "");
        result = result.replace(/\s+$/g,   "");
        result = result.replace(/\s+/g,   " ");
        result = result.replace(/^(\s*\S*(\s+\S+)*)\s*$/, '$1'); // Right trim by Igor Poteryaev.
        return result;
    }

    // The DOM helper functions depend on DOM/DHTML, so they only work in a browser.
    // However, these are not considered core to the engine.
    //
    TrimPath.parseDOMTemplate = function(elementId, optDocument, optEtc) {
        if (optDocument == null)
            optDocument = document;
        var element = optDocument.getElementById(elementId);
        var content = element.value;     // Like textarea.value.
        if (content == null)
            content = element.innerHTML; // Like textarea.innerHTML.
        content = content.replace(/&lt;/g, "<").replace(/&gt;/g, ">");
        return TrimPath.parseTemplate(content, elementId, optEtc);
    }

    TrimPath.processDOMTemplate = function(elementId, context, optFlags, optDocument, optEtc) {
        return TrimPath.parseDOMTemplate(elementId, optDocument, optEtc).process(context, optFlags);
    }
}) ();


    GravityRD.TrimPath = TrimPath;

    try {

        (function (GravityRD) {
    "use strict"

    GravityRD.Base = {
        /**
         * The framework is started through the call of this function. It starts the worker, if already not present, and registers the callback interface.
         */
        start: function (conf) {

            if (!conf || !(conf instanceof Object) || Array.isArray(conf)) {
                throw new Error("Invalid configuration");
            }

            GravityRD.Core.init(conf);

            if (GravityRD.Worker.start()) {

                //register public interface
                var gObj = {
                    responseCallback: function (result) {
                        GravityRD.Core.useResultCB(result);
                    }
                };
                if (GravityRD.Core.config.diagnostic) {
                    GravityRD.Core.config.isManualTrackingCodeTest ? alert("Yuspify integration is OK. Tracking code found.") : "";
                    gObj["diagnostic"] = function () {
                        var data = {
                            properties: {},
                            config: GravityRD.Core.getConfig(),
                        };
                        for (var prop in GravityRD.Core.globalNameValues) {
                            if (!GravityRD.Core.globalNameValues.hasOwnProperty(prop)) continue;
                            data.properties[prop] = GravityRD.Core.globalNameValues[prop];
                        }
                        data.currentPage = data.properties["_Page"] ? data.properties["_Page"][0] : undefined;

                        return data;
                    };
                }
                window["GravityRD"] = gObj;
            }
        },
    };
})(GravityRD);
(function (GravityRD) {

    var utils = {
        extend: function (target, base) {
            var exp = target.prototype;
            target.prototype = Object.create(base.prototype);
            Object.assign(target.prototype, exp);
            target.prototype.constructor = target;
        },

        isObject: function (value) {
            return value !== null && typeof value === 'object';
        },
        isFunction: function (func) {
            return typeof (func) === 'function';
        },

        isString: function (o) {
            return typeof (o) === 'string';
        },
        Object: {},
        Array: {
            /**
             * @param {*} arr
             * @returns {[]}
             */
            normalizeToArray: function (arr) {
                if (arr === undefined) arr = [];
                return Array.isArray(arr) ? arr : [arr];
            },

            /**
             * Pushes unique values from an Array or Single value
             * @param {[]} array
             * @param {[]|*} value
             */
            flatPushUnique: function (array, value) {
                if (Array.isArray(value)) {
                    value.forEach(function (valueItem) {
                        if (array.indexOf(valueItem) === -1) array.push(valueItem);
                    })
                } else if (array.indexOf(value) === -1) {
                    array.push(value);
                }

                return array;
            },
            /**
             * Returns a new array without the values from the exclude list
             * @param {[]} arr
             * @param {[]} exclude
             * @returns {[]}
             */
            except: function (arr, exclude) {
                return exclude.length > 0
                    ? arr.filter(function (key) {
                        return exclude.indexOf(key) === -1;
                    })
                    : arr.slice();
            }
        },
        /**
         *
         * @param {{}} nv
         * @returns {number}
         */
        hash: function (nv) {
            var na = Object.keys(nv);
            na.sort(function (a, b) {
                return a < b ? -1 : (a > b ? +1 : 0);
            });
            var input = "";
            for (var i = 0; i < na.length; i++) {
                var val = nv[na[i]];
                input += na[i] + ":" + (Array.isArray(val) ? val.join(",") : val) + ";";
            }
            // todo: readablity
            var hash = (function (e) {
                for (var r = 0, i = 0; i < e.length; i++) r = (r << 5) - r + e.charCodeAt(i), r &= r;
                return r
            })(input);
            return hash;
        }
    };

    /**
     * Config Container, normalizes config keys to list of values
     * @param data
     * @constructor
     */
    function ValueListDictionary(data) {
        this._data = {};
        Object.defineProperty(this, "_data", {
            enumerable: false,
            configurable: true
        });
        for (var prop in data) {
            if (!data.hasOwnProperty(prop)) continue;
            this.set(prop, data[prop]);
        }

        Object.defineProperty(this,"length",{
            enumerable: false,
            configurable: false,
            get: function () {
                return Object.keys(this).length;
            }
        })
    }

    /**
     * Sets a unique value to a key's list
     * @param {string} key
     * @param {[]|*} value
     */
    ValueListDictionary.prototype.set = function (key, value) {
        var self = this;
        if (!self._data.hasOwnProperty(key)) {
            Object.defineProperty(self, key, {
                get: function () {
                    return self._data[key];
                },
                set: function (v) {
                    if (self._data[key] != null) {
                        utils.Array.flatPushUnique(this._data[key], v);
                    } else {
                        self._data[key] = utils.Array.normalizeToArray(v);
                    }
                },
                enumerable: true,
                configurable: true
            });
        }
        self[key] = value;
    }

    ValueListDictionary.prototype.delete = function (key) {
        if (!this._data.hasOwnProperty(key)) return;
        delete this._data[key];
        delete this[key];
    }

    ValueListDictionary.prototype.unset = function (key, value) {
        if (!this._data.hasOwnProperty(key)) return;
        var index = this._data[key].indexOf(value);
        if (index === -1) return;
        this._data[key].splice(index, 1);
        if (this._data[key].length === 0) {
            delete this._data[key];
            delete this[key];
        }
    }

    ValueListDictionary.prototype.get = function (key) {
        return this[key];
    }


    /**
     *
     * @param {string} key
     * @param {[]|*} value
     */
    ValueListDictionary.prototype.replace = function (key, value) {
        this.delete(key);
        this.set(key, value);
    }

    /**
     * @param {ValueListDictionary} other
     * @param {string[]} [protect=undefined] protect list of properties should be preserved from the instance
     * @returns {ValueListDictionary}
     */
    ValueListDictionary.prototype.merge = function (other, protect) {
        protect = protect || [];
        var instance = new ValueListDictionary();
        var sourceKeys = Object.keys(this);
        var otherKeys = utils.Array.except(Object.keys(other), protect);

        for (var i in sourceKeys) {
            var sKey = sourceKeys[i];
            instance.set(sKey, this[sKey]);
        }

        for (var j in otherKeys) {
            var oKey = otherKeys[j];
            instance.set(oKey, other[oKey]);
        }

        return instance;
    }

    /**
     * @param {ValueListDictionary} other
     * @param {string[]} [protect=undefined] protect list of properties should be preserved from the instance
     * @returns {ValueListDictionary}
     */
    ValueListDictionary.prototype.mergeInFrom = function (other, protect) {
        protect = protect || [];
        var otherKeys = utils.Array.except(Object.keys(other), protect);

        for (var j in otherKeys) {
            var oKey = otherKeys[j];
            this.set(oKey, other[oKey]);
        }
        return this;
    }

    /**
     *
     * @param data
     * @param options
     * @constructor
     */
    function StringValueListDictionary(data, options) {
        this._data = {};
        /** @property {{valueMaxSize: int}} this._options */
        this._options = Object.assign({valueMaxSize: 1024}, options);

        Object.defineProperty(this, "_options", {
            enumerable: false,
            configurable: true
        });

        Object.defineProperty(this, "_data", {
            enumerable: false,
            configurable: false
        });

        for (var prop in data) {
            if (!data.hasOwnProperty(prop)) continue;
            this.set(prop, data[prop]);
        }

        Object.defineProperty(this,"length",{
            enumerable: false,
            configurable: false,
            get: function () {
                return Object.keys(this).length;
            }
        })
    }

    utils.extend(StringValueListDictionary, ValueListDictionary);

    StringValueListDictionary.prototype.set = function (key, value) {
        var self = this;
        if (!self._data.hasOwnProperty(key)) {
            Object.defineProperty(self, key, {
                get: function () {
                    return self._data[key];
                },
                set: function (v) {
                    var nameValueMaxSize = this._options.valueMaxSize;
                    v = utils.Array.normalizeToArray(v)
                        // remove null values
                        .filter(function(item){ if(item != null) return item; })
                        // normalize to string array and capped
                        .map(function (item) {
                            item = item.toString();
                            if (item.length > nameValueMaxSize) {
                                item = item.substring(0, nameValueMaxSize -1);
                                GravityRD.Log.debug("Truncating namevalue '" + key +
                                    "', because it exceeds size limit " + nameValueMaxSize);
                            }
                            return item;
                        });

                    if (self._data[key] != null) {
                        utils.Array.flatPushUnique(this._data[key], v);
                    } else {
                        self._data[key] = utils.Array.normalizeToArray(v);
                    }
                },
                enumerable: true,
                configurable: true
            });
        }
        self[key] = value;
    }

    // /**
    //  * @param {{}} target
    //  * @param {{}} source
    //  * @returns {string[]}
    //  */
    // function getCombinedProps(target, source) {
    //     var sourceProps = Object.keys(source);
    //     var targetProps = Object.keys(target);
    //     var allProps = sourceProps.concat(targetProps);
    //     var uniqueProps = [];
    //     for(var p in allProps){
    //         if(allProps.hasOwnProperty(p) && uniqueProps.indexOf(allProps[p]) === -1) uniqueProps.push(allProps[p]);
    //     }
    //     return uniqueProps;
    // }


    GravityRD.Utils = utils;
    GravityRD.Utils.ValueListDictionary = ValueListDictionary;
    GravityRD.Utils.StringValueListDictionary = StringValueListDictionary;

})(GravityRD);(function (GravityRD) {
    'use strict';

    function EventDispatcher() {
        this.eventContainer = {};
        for (var eventName in EventDispatcher.eventNames) {
            if (!EventDispatcher.eventNames.hasOwnProperty(eventName)) continue;
            this.eventContainer[EventDispatcher.eventNames[eventName]] = [];
        }

        this.trigger = function (event, args) {
            if (!this.eventContainer.hasOwnProperty(event)) throw new Error("Invalid eventName: " + event);
            if (this.eventContainer.length === 0) return;
            this.eventContainer[event].forEach(function (fn) {
                fn.apply(null, args)
            });
        }

        this.register = function (event, fn) {
            if (!this.eventContainer.hasOwnProperty(event)) throw new Error("Invalid eventName: " + event);
            this.eventContainer[event].push(fn);
        }

        this.unregister = function (event, fn) {
            if (!this.eventContainer.hasOwnProperty(event)) throw new Error("Invalid eventName: " + event);
            var fnIndex = this.eventContainer[event].indexOf(fn);
            if (fnIndex === -1) return; // there was nothing to unregister
            this.eventContainer[event].splice(fnIndex, 1);
        }
    }

    EventDispatcher.eventNames = {
        onBeforeEventAdded: 'onBeforeEventAdded',
        onAfterEventAdded: 'onAfterEventAdded',
        onRecommendationRequestAdded: 'onRecommendationRequestAdded',
        onRecommendationRequestHandled: 'onRecommendationRequestHandled',
        onError: 'onError'
    };

    GravityRD.Events = new EventDispatcher();
    GravityRD.eventNames = EventDispatcher.eventNames;

})(GravityRD);/*global $:false*/
(function (GravityRD) {
	'use strict';

	var javascriptEscape = function (s) {
		return String(s).replace(/\\/g, "\\\\").replace(/\0/g, "\\x00").replace(/"/g, "\\x22").replace(/'/g, "\\x27").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/&/g, "\\x26").replace(/</g, "\\x3c").replace(/>/g, "\\x3e").replace(/-/g, "\\x2d");
	};

	/** default modifiers for trimpath rendering */
	var modifiers = {
		"html": function (s) {
			return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
		},
		"javascript": javascriptEscape,
		"js": javascriptEscape,
		"truncate": function (s, l, d) {
			var ret = s;
			if (s.length > l) {
				ret = s.substring(0, l) + d
			}
			return ret;
		},
		"priceformat": function (str, locales, currency) {
			if (str) {
				return new Intl.NumberFormat(locales, {
					style: 'currency',
					currency: currency,
					minimumFractionDigits: 0
				}).format(str.trim());
			} else return str;
		}
	};

	var events = GravityRD.Events;
	var E = GravityRD.eventNames;

	/**
	 * GravityRD.Core API class.
	 *
	 * It contains the core functionality of the JS framework. Documented at function level.
	 */
	function GravityRD_Core () {
		/**
		 * Possible configuration options
		 *
		 * @property {ServerConfiguration} serverConfigDefault
		 */
		this.defaultConfig = Object.freeze({
			/** loading the framework is disabled on this domain (usually set by overlay configurations */
			disabled: false,
			/** Expose diagnostic information */
			diagnostic: false,
			isManualTrackingCodeTest: false,
			/** git sha of the build, set by the build process */
			buildSHA: 'notset',
			/**
			 * @property {string} targetServer the backend endpoint server
			 */
			targetServer: null, // "saas.gravityrd.com"
			/** id of the customer */
			partnerId: null,
			/** add the referrer url to each event */
			// enriches referrer info to the request
			trackReferrer: true, // set to true cos that's how it was
			/** add document.location to each event */
			// enriches referrer info to the request
			trackLocation: true, // set to true cos that's how it was
			/** generate and add a session identifier to each event */

			// todo investigate, if needed then set it permanently, dont make it configurable
			//  ejb/src/main/java/com/gravityrd/receng/main/analytics/AnalyticsHelper.java
			trackSession: false,
			// todo investigate, if needed then set it permanently, dont make it configurable
			//  ejb/src/main/java/com/gravityrd/receng/main/analytics/AnalyticsHelper.java
			/** generate and add a page identifier to each event */
			trackPage: false,

			// todo investigate flip it
			/** is the html5 localstorage allowed to use to gather tracking information. it should be disabled on sites which have several subdomains */
			sessionStorage: true,

			/** should the exceptions thrown at the client logged back to the server */
			logExceptions: true,
			/** is the recid <-> itemid registration is allowed for the client. usefull in cases of mixed backend/frontend integration */
			// todo: mindig true...
			enableRegisterRecId: false,
			/** the cookie path for all the tracking cookies */
			cookiePath: '/',
			/** the cookie domain used for all the tracking cookies */
			/** @param {string|[]|Function} usage: "level-2" 2 szintig hasznalja a location origin/t
			 */
			cookieDomain: null,
			/** should the framework generate a random seed with each request */
			addRandomSeed: false,
			/** how often should the random seed change (in seconds). usefull if displaying ad-like recommendations in several iframes.*/
			randomSeedExpire: 10,
			/** should event sending deferred in case there is no recommendation request waiting in the queue. don't touch this setting, except if you know what you are doing */
			deferEvents: true,
			/** in case events are deferred, how many millisecs to wait before sending the event */
			deferEventsTime: 2000,
			/** expiration time (in seconds) for the the recid <--> itemid internal mapping */
			recClickExpire: 0,
			/** how many items to store in the recid <--> itemid mapping */
			recClickTrackMax: 10,
			/** strings that look like null values wrongly passed, and possibly indicate api usage error*/
			// todo: kuka
			nullStrings: ['null', 'NULL', 'nil', '0'],
			/** namevalues which probably should not used (they are the special parameter of set requests) */
			// todo: kuka, bekerul beegetve a request serializalashoz
			wrongNameValues: [],
			/** list of server side settings the client can override */

			/** make userid setting persistent: false, true, 'session' */
			persistUserId: false,
			nameValueMaxSize: 1024,
			// ex globalConfig
			userId: null,
			cookieName: "gr_reco",
			dynamic: true
		});

		this.locationSearch = {};

		this.userId = "";

		/**
		 * @property {ServerConfiguration} config
		 */
		this.config = null;


		/** the number of requests made by the framework */
		this.requestNumber = 0;
		/** params for the previous requests. this array can be indexed by i = 0..requestNumber -1 */
		this.parmsHistory =  [];
		/** @param {RequestContext} parameters for the actual request to make */
		this.params = null;
		/** internal handle for debouncer timer */
		this.handle = null;
		/** handles fw initialization */
		this.firstCall = true;

		/**
		 * @property {StringValueListDictionary|null} globalNameValues
		 */
		this.globalNameValues = null;

		this.makeValueListDict = function () {
			return new GravityRD.Utils.StringValueListDictionary({},{
				valueMaxSize: this.config["nameValueMaxSize"]
			});
		}

		this.initLocationSearch = function (){
			var self = this;
			self.locationSearch = {};

			if (window.location.search.length > 0) {
				window.location.search
					.substring(1)// remove the '?'
					.split("&") // split to string[]
					// map to [][] array of arrays where first element is the name of the query
					// and the second is the value
					.map(function (value) { return value.split("=") })
					// populate the params
					.forEach(function (value) { self.locationSearch[value[0]] = window.decodeURIComponent(value[1]); });
			}
		}

		this.initGlobalNameValues = function () {
			if(this.globalNameValues){
				GravityRD.Log.info("globalNameValues already set init stops.");
				return;
			}

			if(!this.config){
				GravityRD.Log.info("globalNameValues must initialize after settings are configured");
				return;
			}

			this.globalNameValues = this.makeValueListDict();

			Object.defineProperty(this,"globalNameValues",{writable: false});
		}
		/** todo: user */
		this.userId = "";
		/**
		 * Add a global namevalue. If it exist, they will be merged together into an array.
		 * Global namevalues are appended to all the events and recommendationrequests made.
		 *
		 * @param {String} key
		 * @param {Array|*} val An array of scalar values or a single value
		 * @param {boolean} [overwrite=undefined] overwrite
		 * @param {string|boolean} [persist=undefined] persist Possible values "session"
		 */
		this.addGlobalNameValue = function (key, val, overwrite, persist) {

			if(overwrite){
				this.globalNameValues.replace(key,val);
			}else{
				this.globalNameValues.set(key, val);
			}

			GravityRD.Log.debug("Adding global nameValue '" + key + "':'" + val + "', overwrite=" + overwrite + ", persist=" + persist, this.globalNameValues[key]);

			if (persist === "session") {
				GravityRD.Cookie.addSessionNameValue(key, this.globalNameValues[key]);
			} else if (!!persist) { // explicit false will be skipped
				GravityRD.Cookie.addPersistentNameValue(key, this.globalNameValues[key]);
			}
		};
		/** Overwrite a global namevalue, with the current value specified. */

		this.setGlobalNameValue = function (key, val, persist) {
			this.addGlobalNameValue(key, val, true, persist);
		};


		/**
		 *
		 */
		this.initializeConfig = function () {
			if(this.config){
				GravityRD.Log.info("config already set autoConfigure stops");
				return;
			}

			this.config = Object.seal(Object.assign({},this.defaultConfig));
			Object.defineProperty(this,"config",{writable: false});
		}

		/**
		 * Sets all values from the passed configuration, that already exist on the config
		 * @param {ServerConfiguration} conf
		 */
		this.setConfig = function (conf) {
			// make sure that we don't include illegal properties
			var allowedProps = Object.keys(this.config);
			for(var i in allowedProps){
				var prop = allowedProps[i];
				if(!conf.hasOwnProperty(prop)) continue;
				this.config[prop] = conf[prop];
			}
		}


		/**
		 * @param {string} url
		 * @return {{protocol: string, hostname: string, search: string, port: string, host: string, hash: string, pathname: string}}
		 */
		function parseUrl(url) {
			if(window.URL){
				var urlObj = new URL(url);
				return {
					protocol: urlObj.protocol,
					host: urlObj.host,
					hostname: urlObj.hostname,
					port: urlObj.port,
					pathname: urlObj.pathname,
					search: urlObj.search,
					hash: urlObj.hash
				}
			}else{
				var parser = document.createElement('a');
				parser.href = url;
				return {
					protocol: parser.protocol,
					host: parser.host,
					hostname: parser.hostname,
					port: parser.port,
					pathname: parser.pathname,
					search: parser.search,
					hash: parser.hash
				};
			}
		}


		/**
		 * @param {string} url
		 * @return {null|{origin: string, domain: string, customerName: string}}
		 */
		function matchGRRecoJsURLDomain(url) {
			var urlObj = parseUrl(url);
			var domainMatch = urlObj.hostname.match("yusp.com$");
			if(!domainMatch) return null;
			var jsMatch = urlObj.pathname.match("/\gr_reco.+\.js$");
			if(!jsMatch) return null;
			var customerName = urlObj.hostname
				.replace("engine.","") // removes engine if present
				.replace(".yusp.com","") // removes yusp upperdomain

			return {
				origin: urlObj.protocol + "//" + urlObj.hostname,
				domain: urlObj.hostname,
				customerName: customerName
			}
		}

		/**
		 *
		 * @param {[]} arr
		 * @return {[]}
		 */
		this.spliceSetCommands = function (arr) {
			var indices = [];
			var settings = [];
			for(var i in arr){
				if(arr[i].type === "config"){
					indices.push(i);
					settings.push(arr[i]);
				}
			}
			for(var j=0; j < indices.length; j++){
				var index = indices[j] - j;
				arr.splice(index,1);
			}
			return settings;
		}

		/**
		 * @param {{}} conf
		 * @param {[]} [fromArray=undefined] fromArray
		 */
		this.processEnqueuedConfig = function (conf, fromArray) {
			fromArray = fromArray || window._gravity;
			if(Array.isArray(fromArray)){
				var uninitializedConfig = GravityRD.Core.spliceSetCommands(fromArray);
				uninitializedConfig.unshift(conf);
				Object.assign.apply(null, uninitializedConfig);
				if(conf.hasOwnProperty("type")) delete conf.type;
			}
		}

		/**
		 * Initializes configuration, apply overlay configs
		 * @deprecated remove and rely on pre-init configuration
		 * @param {ServerConfiguration} config
		 */
		this.autoConfigure = function(config){
			// determine if we need autoconfiguration
			// We can abort if:
			// - customerName is set
			// - targetServer is set
			if(config.partnerId && config.targetServer)
				return;

			var scriptTags = document.getElementsByTagName('script');

			for (var k = 0; k < scriptTags.length; k++) {
				var match = matchGRRecoJsURLDomain(scriptTags[k].src || "");
				if(match !== null){
					if (!this.config.partnerId) {
						this.config.partnerId = match.customerName;
					}
					if (!this.config.targetServer) {
						this.config.targetServer = match.domain;
					}
					break;
				}
			}
		}

		/**
		 * @param {{type:string, userId:string}} setting
		 */
		this.setUser = function (setting) {
			var currentUserId = this.userId;
			var userIdStore = this.config.persistUserId;
			this.userId = setting.userId;

			if (setting.userId !== currentUserId && this.parmsHistory.length !== 0) {
				GravityRD.Log.debug("The userId has changed: emptying buffers.");
				this.clearScheduledRequest();
				this.request();
			}

			if ("session" === userIdStore) {
				GravityRD.Cookie.addSessionNameValue("userId", setting.userId);
			} else if (userIdStore === false) {
				// do not persist
			} else {
				GravityRD.Cookie.addPersistentNameValue("userId", setting.userId);
			}
		}

		/**
		 * Sets configuration entries for configurable entries
		 * Enriches GlobalNameValues with non-configurable entries
		 * Client issued 'set' typed push requests are redirechcted here
		 *
		 * Sets Client
		 * @param {{}} rd
		 */
		this.set = function (rd) {
			var keys = Object.keys(rd);

			var overwrite = !!rd.overwrite || false;

			for(var i in keys){
				var key = keys[i];
				if(rd[key] === "type" || rd[key] === "overwrite") continue;
				this.addGlobalNameValue(key, rd[key], overwrite);
			}
		};

		/** Return the actual request number */
		this.getRequestNumber = function () {
			return this.requestNumber;
		};

		/**
		 * Client issued 'event' typed pushrequests are redirected here
		 * @param {EventRequestOptions} rd
		 */
		this.addEvent = function (rd) {
			// @note: recommendationId is simply a legacy thing that should not be used
			rd.recId = rd.recommendationId || rd.recId;
			rd.recommendationId = undefined;

			events.trigger(E.onBeforeEventAdded, [rd]);

			// Enriching the RD with recID?
			// Barmilyen event jon es van itemId-je akkor az azt ajanlo recommendation id-jevel feldusitjuk
			if (!rd.recId) {
				var rid;
				if (rd.eventType === 'REC_CLICK' || rd.eventType === 'SHOW_RECOMMENDATION') {
					// @review ha nincs itemId akkor ez OK?
					if (rd.itemId) {
						// in mem storagebol visszajon a recommendation lejon akkor melyik item milyen recid/vel jott
						// ezert ha barmelyik itemre keletkezik event tudjuk, hogy h. melyik recomendation bol jott
						rid = GravityRD.Cookie.getRecId(rd.itemId);
						if (rid != null) {
							GravityRD.Log.debug("Adding recId '" + rid + "' for event '" + rd.eventType + "', item '" + rd.itemId + "'");
							if (rd.eventType === 'REC_CLICK') {
								// csak siman lementjuk, hogy erre az itemre lett click
								// ez valahova viszont kimentidik
								GravityRD.Cookie.registerRecClickId(rd.itemId, rid);
							}
							rd.recId = rid;
						}
					}
				}
				//
				// else {
				// 	// getRecClickId mar volt-e egyeltalan volt-e click
				// 	rid = GravityRD.Cookie.getRecClickId(rd.itemId);
				// 	if (rid != null) {
				// 		GravityRD.Log.debug("Adding recClickId '" + rid + "' for event '" + rd.eventType + "', item '" + rd.itemId + "'");
				// 		rd.recId = rid;
				// 	}
				// }
			}
			this.addLocationAndReferrer("event", rd);
			this.params.events.push(rd);
			events.trigger(E.onAfterEventAdded, [rd]);
		};
		/**
		 * Add the document.location and the referrer as a namevalue in case it is specified in the config,
		 * to the underlying request
		 * @param {string} type
		 * @param {EventRequestOptions} rd the event to be enriched
		 */
		this.addLocationAndReferrer = function (type, rd) {
			var config = GravityRD.Core.getConfig();
			var trackReferrer = config["trackReferrer"] || {};
			if (trackReferrer === true || trackReferrer[type] === true) {
				if (document.referrer != null) {
					GravityRD.Log.debug("Adding referrer '" + document.referrer + "' for " + type, rd);
					rd._referrer = document.referrer;
				}
			}
			var trackLocation = config["trackLocation"] || {};
			if (trackLocation === true || trackReferrer[type] === true) {
				if (document.location.href != null) {
					GravityRD.Log.debug("Adding location '" + document.location.href + "' for " + type, rd);
					rd._location = document.location.href;
				}
			}
		};
		/** Add random seed to the recommendation request in case it is specified in the config */
		this.addRandomSeed = function (rd) {
			if (GravityRD.Core.getConfig()["addRandomSeed"]) {
				rd.GravityRandomSeed = GravityRD.Cookie.getRandomSeed();
			}
		};

		/**
		 * Client issued 'recommendation' typed pushrequests are redirected here
		 * @property {RecommendationRequestConfig} rd
		 */
		this.addRecommendationRequest = function (rd) {
			this.checkTemplating(rd);
			rd.recommendationIndex = this.params.recommendationRequests.length;
			if (rd.groupId) {
				if (rd.groupSeq === undefined) {
					throw new Error(GravityRD.Log.errorMessages.GR023);
				}
				var index = -1;
				for (var i = 0; i < this.params.recommendationRequests.length; i++) {
					if (this.params.recommendationRequests[i].groupId === rd.groupId) {
						index = i;
						break;
					}
				}
				if (index === -1) {
					if (rd.groupSize === undefined) {
						throw new Error(GravityRD.Log.errorMessages.GR024);
					}
					if (rd.groupSize < 1) {
						throw new Error(GravityRD.Log.errorMessages.GR026);
					}
					if (rd.groupSize === 1) {
						rd.__completed = true;
					}
				} else {
					var last = this.params.recommendationRequests[index];
					var size = last.groupSize;
					if (rd.groupSize) {
						if (rd.groupSize !== size) {
							throw new Error(GravityRD.Log.errorMessages.GR027);
						}
					}
					var seq = 1;
					while (last.__next !== undefined && last.__next !== null) {
						seq = seq + 1;
						last = last.__next;
					}
					if (seq + 1 === rd.groupSeq) {
						last.__next = rd;
						if (seq + 1 === size) {
							last = this.params.recommendationRequests[index];
							last.__completed = true;
							while (last.__next !== undefined && last.__next !== null) {
								last = last.__next;
								last.__completed = true;
							}
						}
					} else {
						throw new Error(GravityRD.Log.errorMessages.GR025);
					}
				}
			}
			this.addLocationAndReferrer("recommendation", rd);
			this.addRandomSeed(rd);
			this.params.recommendationRequests.push(rd);
			events.trigger(E.onRecommendationRequestAdded, [rd]);
		};
		/**
		 * Check if templating parameters are correctly specified
		 * @property {RecommendationRequestConfig} rd
		 */
		this.checkTemplating = function (rd) {
			if (rd.templating === undefined && rd.callback === undefined) {
				throw new Error(GravityRD.Log.errorMessages.GR016);
			}
			// checking for targetElementId
			if (rd.templating) {
				rd.templating.serverSide = false;
				if (rd.templating.templateElementId) {
					if (rd.templating.template) {
						throw new Error(GravityRD.Log.errorMessages.GR013);
					}
					var element = document.getElementById(rd.templating.templateElementId);
					if (element != null) {
						rd.templating.template = element.innerHTML;
					} // todo: handle null with punishment ex
					// hova megy a render
				} else if (rd.templating.templateId !== undefined && rd.templating.template === undefined) {
					GravityRD.Log.debug("Server side templating");
					rd.templating.serverSide = true;
				} else {
					if (rd.templating.template === undefined) {
						throw new Error(GravityRD.Log.errorMessages.GR014);
					}
				}
			}
			if (rd.templating && rd.templating.template === undefined && rd.templating.templateId === undefined) {
				throw new Error(GravityRD.Log.errorMessages.GR015);
			}
			if (rd.templating && rd.templating.template && rd.templating.templateId) {
				throw new Error(GravityRD.Log.errorMessages.GR030);
			}
		};
		/**
		 * Returns an immutable copy of Configuration
		 * @return {ServerConfiguration}
		 */
		this.getConfig = function () {
			return this.config;
		};
		/** Calling this function will create a backend request from the built up params. */
		this.request = function () {
			var dequeue = GravityRD.Cookie.dequeueEvents() || [];
			var uid = this.userId;

			// todo: check if it is valid not to filter out all changed uid
			if (dequeue.length > 0 && dequeue[0].__userId !== uid) {
				GravityRD.Log.debug("Warning: 'uid' and 'euid' is different, possible misconfiguration issue. uid:" + uid + ", euid:" + dequeue[0].__userId);
				var localParams = {
					events: dequeue,
					requestNameValues: [],
					recommendationRequests: [],
					templateData: {}
				};
				GravityRD.Request.createRequest(this.getConfig(), localParams, this.userId);
				GravityRD.Request.createRequest(this.getConfig(), this.params, this.userId);
			} else {
				this.params.events = dequeue.concat(this.params.events);
				GravityRD.Request.createRequest(this.getConfig(), this.params, this.userId);
			}
		};
		/**
		 * @param {string} targetServer
		 * @param {string} partnerId
		 * @param {boolean|*} [testMode]=undefined testMode
		 * @return {string}
		 */
		this.getCustomJSSrc = function (targetServer, partnerId, testMode) {
			var debugParam = testMode === true ? "&env=test" : "";
			return '//' + targetServer + '/grrec-' + partnerId + '-war/JSServlet4?cc=1' + debugParam;
		};
		/**
		 * @param {NodeList} scripts
		 * @param {string} customJSSrc
		 * @return {boolean}
		 */
		this.isCustomJSAlreadyIncluded = function (scripts, customJSSrc) {
			for (var i in scripts) {
				if (!scripts.hasOwnProperty(i)) continue;
				var s = scripts[i];
				if (s.innerText.indexOf(customJSSrc) !== -1) {
					return true;
				}
			}
			return false;
		};
		/**
		 * @param {ServerConfiguration} conf
		 */
		this.initCustomJs = function (conf) {
			if (!conf.dynamic) return;

			GravityRD.Log.group("CustomJS detection", true)
			var scripts = document.getElementsByTagName("script");

			if (this.isCustomJSAlreadyIncluded(scripts, this.getCustomJSSrc(conf.targetServer, conf.partnerId))) {
				GravityRD.Log.info("Auto customjs inclusion aborted, it is already included");
				return;
			}

			var testMode = !!this.locationSearch[TEST_MODE_PARAM];
			var head = scripts[0].parentElement;
			var script = document.createElement("script");
			script.defer = 1;
			script.src = this.getCustomJSSrc(conf.targetServer, conf.partnerId, testMode);
			head.appendChild(script);

			GravityRD.Log.info("Auto customjs included");
			GravityRD.Log.groupEnd();
		};
		/**
		 * Initializes Core Module
		 * @param {ServerConfiguration} conf
		 */
		this.init = function (conf) {
			this.initParams();
			this.initializeConfig();
			this.initLocationSearch();
			this.configureDiagnostic(conf);
			this.configureManualCheck(conf);
			this.processEnqueuedConfig(conf);
			this.autoConfigure(conf);
			this.initCustomJs(conf);
			this.setConfig(conf);
			this.initGlobalNameValues();
		};
		this.configureDiagnostic = function (conf){
			conf.diagnostic = this.locationSearch["diag"] === "1";
		};
		this.configureManualCheck = function (conf){
			conf.isManualTrackingCodeTest = this.locationSearch["manualTrackingCodeTest"] === "1";
		};
		/**
		 *
		 * This function schedules the #request() function to run in the specified milliseconds. indicates to run
		 * immediatelly after the call stack got empty. -1 indicated to clear the pending timeout.
		 *  Debouncer like, it will keep canceling
		 */
		this.scheduleRequest = function (ms) {
			this.handle = window.setTimeout(this.request.bind(this), ms);
		};

		this.clearScheduledRequest = function (){
			if (this.handle != null) {
				window.clearTimeout(this.handle);
				this.handle = null;
			}
		}

		this.freezeConfig = function () {
			if(!Object.isFrozen(this.config)) Object.freeze(this.config);
		};
		var TEST_BAR_ID = "yusp-test-bar";
		var TEST_MODE_PARAM = "yuspTest";
		this.testMode = false;
		this.turnTestModeOn = function (){
			this.globalNameValues.set("TestMode",1);
			this.testMode = true;
			if(document.getElementById("yusp-test-mode-wrapper") == null) this.addTestModeFrame();
		};
		this.addTestModeFrame = function (){
			var div = '<style>.yusp-test-mode-wrapper{height: 50px !important; position: fixed !important; z-index: 10000 !important;top:0; }.yusp-test-mode-text-wrapper {width: auto !important;border-right: 1px solid #e4e4e4 !important;padding-left: 1rem !important;padding-right: 1rem !important;display: flex !important;align-items: center !important;justify-content: space-between !important; background: white; border-bottom: 1px solid #e4e4e4; height: 100%;}.yusp-test-mode-text {font-family: "Gill Sans", sans-serif; padding: 0 10px;}.yusp-test-mode-publish{display: flex !important;cursor: pointer !important;align-items: center !important;justify-content: space-between !important;width: 94px !important;padding: 0.5rem !important;margin-left: 0.8rem !important;-webkit-box-shadow: 0px 0px 7px 1px rgba(0,0,0,0.3);-moz-box-shadow: 0px 0px 7px 1px rgba(0,0,0,0.3);box-shadow: 0px 0px 7px 1px rgba(0,0,0,0.3);}.yusp-test-mode-publish:hover {background-color: #e0e4ec;}.yusp-test-mode-publish span {font-family: "Gill Sans", sans-serif;}</style><div id="yusp-test-mode-wrapper" class="yusp-test-mode-wrapper"><div class="yusp-test-mode-text-wrapper"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAABfklEQVRIieXTu2sUURQG8N+dYQMhPptgEbCJj0JBQRAUxDr2QQ1aiJ1g5aMSomhhIaxaWQV0h0D+C7HUTkS0trAUxELX7LFYo7vZmdnZkEq/8p7zve7c4b9CrDoXhYVJOKmx+DMtO7xFbq8jacH3JryscZQZ13EI87641pTWqEE8Nyv3Ebt/H33VcjAt+jyO26xB7sGAOOz0070m1LENYtVxPa+Rbxr1ZE6mC97U8cc36GmXiPe56x5H1IesNYjCeZypXEhOKSzWaVS6x5ppXe+x/8/yUn8/CjGw+sm6w+myb2U61Q26bg+K12BO7mbVsNQgOuZwo4H4Bm5FUR6mqsEjzExgMI2HZYORbxAdpyWvymZjkZxNF70cPBpqEMsySXtL4hDasTb8pIev6ICrOFEZcEnaeEkVOOaHK6UG0bFLuDtR4tIU7seKPSMGkmXJvjpuFGLTP1CGWVPu/JVFvDAv8w5TW0o9iq6eo+mSD/0GmSfbKA4tmafbqPcv4xc2YVDsmHEFiAAAAABJRU5ErkJggg==" alt="problem" /><span class="yusp-test-mode-text">yusp preview mode </span></div></div>';
			document.body.insertAdjacentHTML('beforeend', div);
		};
		/**
		 * This function is called by the worker to process all the push-requests in the queue
		 * @property {[]} queue
		 * @property {Boolean} force
		 */
		this.process = function (queue, force) {
			GravityRD.Log.group("Processing", true);
			var submit = this.firstCall;
			this.firstCall = false;
			submit |= (force || false);
			var config = GravityRD.Core.getConfig();
			var self = this;

			for (var l = 0; l < queue.length; l++) {
				// Commandon azert van kinn, h. tujduk ki volt az aktualis userid
				var command = queue[l];
				if (!(command.type === "set")) {
					command = Object.assign({},this.globalNameValues, command)
					command.__userId = this.userId;
				}
				// GravityRD.Typecheck.pushObjectChecker(command).validate();
				if (command.type === "recommendation") {
					this.addRecommendationRequest(command);
					submit = true;
				} else if (command.type === "event") {
					this.addEvent(command);
				} else if (command.type === "config") {
					this.setConfig(command);
				} else if (command.type === "user") {
					this.setUser(command);
				} else if (command.type === "set") {
					this.set(command);
				} else if (command.type === 'register-recid') {
					if (config["enableRegisterRecId"] === true) {
						for (var i = 0; i < command.itemId.length; i++) {
							GravityRD.Cookie.registerRecId(command.itemId[i], command.recId);
						}
					} else {
						throw new Error(GravityRD.Log.errorMessages.GR019);
					}

				} else if (command.type === 'domready') {
					GravityRD.CustomConfig.addInitCallback(command.apply, true);
				} else if (command.type === 'customconfig') {
					/** @param {CustomConfigCommand} c */
					window.setTimeout((function (c) {
						return function () {
							GravityRD.CustomConfig.set(c.config, c.environment);
							if(c.environment === "test"){
								self.turnTestModeOn();
							}
							GravityRD.CustomConfig.init();
						}
					})(command), 0);
				} else if (command.type === 'liveeditor') {
					// start the liveeditor
					var apiBaseUrl = window.location.protocol + "//" + GravityRD.Core.config.targetServer;
					command.main.call(undefined, apiBaseUrl, this.locationSearch, TrimPath);
				} else {
					GravityRD.Log.error("Invalid type specified for push object!", queue);
				}
			}

			GravityRD.Log.groupEnd();

			if (config["deferEvents"] === false || submit /* || this.parmsHistory.length == 0 */) {
				GravityRD.Log.debug("Immediate submit");
				this.clearScheduledRequest();
				this.request();
			} else {
				GravityRD.Log.debug("Defered submit");
				GravityRD.Cookie.queueEvents(this.params.events);
				this.params.events = [];
				this.scheduleRequest(config["deferEventsTime"]);
			}
		};
		/**
		 * Initializes / Overwrites this.params internal structures of a new request
		 *
		 * @param {RecommendationRequestConfig[]} [recommendationRequests=undefined] recommendationRequests
		 * @param {[]} [e=undefined] e events
		 */
		this.initParams = function (recommendationRequests, e) {
			this.params = {
				events: e || [],
				requestNameValues: [],
				recommendationRequests: recommendationRequests || [],
				templateData: {}
			};
			for (var i = 0; i < this.params.recommendationRequests.length; i++) {
				this.params.recommendationRequests[i].recommendationIndex = i;
			}
		};
		/**
		 * Saves the current internal params of a backend request into a history array.
		 * We will need them when processing callbacks from the server
		 *
		 * @param {RecommendationRequestConfig[]} recommendationRequests
		 */
		this.saveParams = function (recommendationRequests) {
			GravityRD.Log.debug("Remaining", recommendationRequests);
			this.params['ts'] = +new Date();
			this.parmsHistory.push(this.params);
			this.initParams(recommendationRequests);
			this.requestNumber++;
		};
		
		/**
		 * Callbacks from the server are redirected to this function. It is responsible to render all the templates
		 * specified, and call the registered client-callback functions.
		 */
		this.useResultCB = function (result) {
			GravityRD.Request.useResultCB(result); // error handling
			GravityRD.Log.debug("useResultCB", result);
			if (result && result.recommendationWrappers) {
				for (var i = 0; i < result.recommendationWrappers.length; i++) {
					var recIndex = result.recommendationWrappers[i].recommendationIndex;
					var recRequest = this.parmsHistory[result.requestNumber].recommendationRequests[recIndex];
					var recommendation = result.recommendationWrappers[i].recommendation;
					var recId = recommendation.recommendationId;

					if (recommendation.items !== undefined) {
						(function () {
							var savedrec = recommendation;
							var savedrecid = recId;
							var savedURI = "rec://" + recRequest.scenarioId + "/" + result.requestNumber + "/" + recIndex;
							window.setTimeout(function () {
								GravityRD.Log.group("Registering of recids for " + savedURI, true);
								for (var j = 0; j < savedrec.items.length; j++) {
									GravityRD.Cookie.registerRecId(savedrec.items[j].itemid, savedrecid);
								}
								GravityRD.Log.groupEnd();
							}, 0);
						})();
					}

					if (recRequest.templating !== undefined) {
						if (!recRequest.templating.serverSide) {
							var targetId = recRequest.templating.targetElementId;
							var target = document.getElementById(targetId);
							recommendation.templateData = recRequest.templating.templateData;
							recommendation.template = recRequest.templating.template;
							recommendation._MODIFIERS = recRequest.templating.modifiers || {};
							recommendation.template = recommendation.template
								.replace(/&lt;/g, "<")
								.replace(/&gt;/g, ">")
								.replace(/&amp;/g, "&");

							/*
							 Note: data is a shallow copy. Modifiers will be mutated below while items not.
							 */
							var data = Object.assign({}, recommendation);
							data.template = recommendation.template
								.replace(/\${[^}]*/igm, function(s){
									return s.toLowerCase()
										.replace(" ",'') // this fixes unwanted line breaks in var names
								});
							Object.assign(data._MODIFIERS, modifiers);
							var elementToHide = Object.hasOwnProperty.call(recRequest, "elementToHide") ? recRequest.elementToHide : undefined;
							data = typeof recRequest.dataModifier === 'function' ? recRequest.dataModifier(data, elementToHide) : data;
							data.items = this._normalizeItemsKeysToLowerCase(recommendation.items);
							try {
								var resultHTML = GravityRD.TrimPath.parseTemplate(data.template).process(data, {
									throwExceptions: true
								});
								if (recRequest.templating.replace === true) {
									var wrapper = document.createElement('div');
									wrapper.innerHTML = resultHTML;
									while (wrapper.children.length !== 0) {
										target.parentNode.insertBefore(wrapper.children[0], target);
									}
									target.parentNode.removeChild(target);
								} else {
									target.innerHTML = resultHTML;
								}
							} catch (e) {
								throw new Error(GravityRD.Log.errorMessages.GR028);
							}

						} else if (recommendation.content !== undefined && recRequest.templating.serverSide) {
							// we have a server side generated template
							// todo throw error if null?
							var targetElement = document.getElementById(recRequest.templating.targetElementId);
							if (targetElement !== undefined) {
								targetElement.innerHTML = recommendation.content;
							}
						}
					}
					if (typeof recRequest.callback === 'function') {
						try {
							recRequest.callback(recommendation, recRequest.templating);
						} catch (e) {
							GravityRD.Log.error("Exception during callback evaluation (recommendation) ", e);
						}
					}

					events.trigger(E.onRecommendationRequestHandled,[recRequest,recommendation]);
				}
			}
		};
		/**
		 * Creates a new array of normalizer
		 * Conflicting keys will retain their first value
		 *
		 * @param {{}[]} items
		 * @return {[]} list of normalized items
		 * @private
		 */
		this._normalizeItemsKeysToLowerCase = function(items){
			var result = [];
			for(var i in items){
				var item = items[i];
				var keys = Object.keys(items[i]);
				var newItem = {};
				for(var j in keys){
          if(keys.hasOwnProperty(j)) {
            var key = keys[j].toLowerCase();
            if (newItem.hasOwnProperty(key)) continue; // skip already present
            newItem[key] = item[keys[j]];
          }
				}
				result.push(newItem);
			}
			return result;
		}
		/**
		 * @param {int} recommendationNumber
		 * @param {int[]} recommendationIndicies
		 */
		this.errorCB = function(recommendationNumber, recommendationIndicies) {
			if (recommendationIndicies !== null) {
				for (var i = 0; i < recommendationIndicies.length; i++) {
					var recIndex = recommendationIndicies[i]
					var recRequest = this.parmsHistory[recommendationNumber].recommendationRequests[recIndex];
					if (recRequest.error !== undefined) {
						try {
							recRequest.error(recRequest.templating);
						} catch (e) {
							GravityRD.Log.error("Exception during error callback evaluation (recommendation) ", e);
						}
					}
				}
			}
		};

		/**
		 * @param {...*}
		 */
		this.onUsageError = function () {
			var args = arguments;
			var arr = Array.apply(null, Array(arguments.length))
				.map(function (_, i) {return args[i];});
			events.trigger(E.onError, arr);
		}
	}

	GravityRD.Core = new GravityRD_Core();

	if(TEST){
		GravityRD.TestCore = GravityRD_Core;
	}

})(GravityRD);
(function (GravityRD) {
    'use strict'

    /**
     * Simple keyvalue abstraction layer on top of the browser's 'localStorage',
     * Note: localstorage is strictly bounded to the document location
     * @private
     */
    var localSessionStore = {
        set: function (name, value) {
            localStorage.setItem(name, value);
        },
        get: function (name) {
            return localStorage.getItem(name);
        }
    };

    /**
     * Simple keyvalue abstraction implemented by browser cookies
     * Note: information accessibility is based on the configured 'cookiePath'
     * @private
     */
    var cookieSessionStore = {
        set: function (name, value) {
            var config = GravityRD.Core.getConfig();
            var cookie = name + "=" + value + ";path=" + config["cookiePath"];
            var cookieDomainVal = GravityRD.Cookie.resolveCookieDomain(
                config,
                document.location.host
            );
            if (cookieDomainVal !== null) {
                cookie += ";domain=" + cookieDomainVal;
            }
            document.cookie = cookie;
        },

        get: function (name) {
            var cookie = document.cookie;
            if (cookie.length > 0) {
                var start = cookie.indexOf(name + "=");
                if (start !== -1) {
                    start = start + name.length + 1;
                    var c_end = cookie.indexOf(";", start);
                    if (c_end === -1) {
                        c_end = cookie.length;
                    }
                    return cookie.substring(start, c_end);
                }
            }
            return null;
        }
    };

    /**
     * Simple provider object for SessionStore. It chooses between CookieSessionStore and LocalSessionStore,
     * based on the settings and the availability of browser functions.
     * @private
     * todo: a class here is overkill, refact someday
     */
    function SessionStoreProvider() {
        this.instance = null;
        this.provide = function () {
            if (this.instance === null) {
                var config = GravityRD.Core.getConfig();
                var localStoreEnabled = false;
                try {
                    localStoreEnabled = window.localStorage != null && config["sessionStorage"] === true;
                } catch (e) {
                }
                if (localStoreEnabled) {
                    try {
                        window.localStorage.setItem("gr_localstoretest", "test");
                        window.localStorage.removeItem("gr_localstoretest");
                    } catch (e) {
                        localStoreEnabled = false;
                    }
                }
                if (localStoreEnabled) {
                    this.instance = localSessionStore;
                } else {
                    this.instance = cookieSessionStore;
                }
            }
            return this.instance;
        }
    }

    /**
     *  Data stored at the client's side.
     *  @private
     */
    function ClientObject(cookieName) {
        this.cookieName = cookieName;
        this.handle = null;
        this.storageProvider = new SessionStoreProvider();
    }

    /**
     * @review is it true that this is always an Array
     * @param key
     * @returns {[]}
     */
    ClientObject.prototype.getValue = function (key) {
        var cookieRawVal = this.storageProvider.provide().get(this.cookieName);
        var cacheObj = JSON.parse(cookieRawVal) || {};
        return cacheObj[key];
    };

    ClientObject.prototype.getAllValues = function () {
        var cookieRawVal = this.storageProvider.provide().get(this.cookieName);
        var cacheObj = JSON.parse(cookieRawVal) || {};
        return cacheObj;
    };

    ClientObject.prototype.setAllValues = function (values) {
        this.storageProvider.provide().set(this.cookieName, JSON.stringify(values), 0);
    };

    ClientObject.prototype.setValue = function (key, value) {
        var cookieRawVal = this.storageProvider.provide().get(this.cookieName);
        var cacheObj = cookieRawVal ? JSON.parse(cookieRawVal) : {};
        cacheObj[key] = value;
        this.storageProvider.provide().set(this.cookieName, JSON.stringify(cacheObj), 0);
    };

    ClientObject.prototype.removeValue = function (key) {
        var cookieRawVal = this.storageProvider.provide().get(this.cookieName);
        var cacheObj = cookieRawVal ? JSON.parse(cookieRawVal) : {};
        delete cacheObj[key];
        this.storageProvider.provide().set(this.cookieName, JSON.stringify(cacheObj), 0);
    };

    ClientObject.prototype.push = function (item, maxsize) {
        var cookieRawVal = this.storageProvider.provide().get(this.cookieName);
        var cacheObj = cookieRawVal ? JSON.parse(cookieRawVal) : [];
        cacheObj.push(item);

        if (maxsize !== undefined) {
            if (cacheObj.length > maxsize) {
                cacheObj = cacheObj.slice(cacheObj.length - maxsize);
            }
        }
        this.storageProvider.provide().set(this.cookieName, JSON.stringify(cacheObj), 0);
    };

    ClientObject.prototype.get = function () {
        var cookieRawVal = this.storageProvider.provide().get(this.cookieName);
        var cacheObj = (cookieRawVal !== null) ? JSON.parse(cookieRawVal) : null;
        return cacheObj;
    };


    /**
     *  Data stored at the client's side.
     *  @param {String} cookieName
     */
    function ClientSessionObject(cookieName) {
        this.cookieName = cookieName;
        this.handle = null;

        this.storageProvider = {
            instance: null,
            provide: function () {
                if (this.instance == null) {
                    this.instance = cookieSessionStore;
                }
                return this.instance;
            }
        }
    }

    GravityRD.Utils.extend(ClientSessionObject, ClientObject);


    /**
     *  Data stored at the client's side with some expiration date.
     */
    function ExpiringClientObject(name) {
        this.times = new ClientObject(name + "_ts");
        this.values = new ClientObject(name);
        this.handle = null;
    }

    ExpiringClientObject.prototype.getValue = function (key) {
        window.setTimeout(this.clearOldValues.bind( this), 0);
        var d = +new Date();
        var kd = this.times.getValue(key);
        if (this.timeout() === 0 || kd + this.timeout() > d) {
            return this.values.getValue(key);
        } else {
            GravityRD.Log.debug("Removing key from " + this.cookieName + ", because it expired: " + key + " (request)");
            this.values.removeValue(key);
            this.times.removeValue(key);
            return null;
        }
    },

        ExpiringClientObject.prototype.setValue = function (key, value) {
            window.setTimeout(this.clearOldValues.bind(this), 0);
            this.values.setValue(key, value);
            this.times.setValue(key, +new Date());
        },

        ExpiringClientObject.prototype.clearOldValues = function () {

            var maxsize = this.maxSize();
            var d = +new Date() - this.timeout();
            var vall = this.values.getAllValues();
            var tall = this.times.getAllValues();
            var tlen = 0;
            var kmin = null, karg = null;
            for (var k in tall) {
                if (this.timeout() !== 0 && tall[k] < d) {
                    GravityRD.Log.debug("Removing key from " + this.cookieName + ", because it expired: " + k + " (thread)");
                    delete tall[k];
                    delete vall[k];
                } else {
                    tlen++;
                    if (kmin === null || tall[k] < kmin) {
                        kmin = tall[k];
                        karg = k;
                    }
                }
            }

            if (tlen > maxsize && karg !== null) {
                GravityRD.Log.debug("Removing key from " + this.cookieName + ", because it exceeds size limit: " + karg + " (thread)");
                delete tall[karg];
                delete vall[karg];
            }

            this.values.setAllValues(vall);
            this.times.setAllValues(tall);
        },

        ExpiringClientObject.prototype.getKeys = function () {

            var ret = [];
            for (var key in this.values.getAllValues()) {
                ret.push(key);
            }
            return ret;
        },

        ExpiringClientObject.prototype.timeout = function () {
            return 0;
        },

        ExpiringClientObject.prototype.maxSize = function () {
            return 100;
        }


    /**
     * This subclass of ExpiringClientObject represent the recid <-> id mapping for REC_CLICK events.
     * @param {String} name
     */
    function RecClickMapping(name) {
        // todo: apply super constructor calling
        this.times = new ClientObject(name + "_ts");
        this.values = new ClientObject(name);
        this.handle = null;
    }

    RecClickMapping.prototype.timeout = function () {
        return (GravityRD.Core.getConfig()["recClickExpire"] || 0) * 1000;
    };

    RecClickMapping.prototype.maxSize = function () {
        return GravityRD.Core.getConfig()["recClickTrackMax"] || 20;
    };

    GravityRD.Utils.extend(RecClickMapping, ExpiringClientObject);

    /**
     * Simple implementation of an 'in-memory object', which has the same interface as ClientObject.
     */
    function InMemoryObject() {
        this.storage = {};

        /**
         * @param {string} key
         */
        this.getValue = function (key) {
            return this.storage[key];
        };

        /**
         *
         * @param {string} key
         * @param {*} value
         * @return {*}
         */
        this.setValue = function (key, value) {
            return this.storage[key] = value;
        };

        this.getKeys = function () { return Object.keys(this.storage); }
    }

    /**
     * This class represents the recid <-> id mapping for recommendations on the current page. It is implemented as a wrapper of the the InMemoryObject class.
     */
    function RecIdMapping() {
        this.local = new InMemoryObject();

        this.registerRecId = function (itemId, recId) {
            GravityRD.Log.debug("RegisterRecId for '" + itemId + "': '" + recId + "'");
            this.local.setValue(itemId, recId);
        };

        /**
         * @param {string} itemId
         * @return {*|null}
         */
        this.getRecId = function (itemId) {
            var ret = this.local.getValue(itemId) || null;
            GravityRD.Log.debug("GetRecId for '" + itemId + "': '" + ret + "'");
            return ret;
        };
    }

    /**
     * This class is a holder for a random seed object, which is constant for some seconds.
     * It is usefull for clients who integrate through iframes.
     * @param {String} name
     */
    // todo check what is this => extend
    function RandomSeed(name) {
        this.times = new ClientObject(name + "_ts");
        this.values = new ClientObject(name);
        this.handle = null;
    }

    RandomSeed.prototype.timeout = function () {
        return (GravityRD.Core.getConfig()["randomSeedExpire"] || 10) * 1000;
    };
    RandomSeed.prototype.maxSize = function () {
        return 1;
    };
    RandomSeed.prototype.getRandomSeed = function () {
        var rs = this.getValue("_");
        if (rs === null) {
            rs = Math.floor(Math.random() * 4294967296);// 2^^32
            this.setValue("_", rs);
        }
        return rs;
    };


    GravityRD.Utils.extend(RandomSeed, ExpiringClientObject);

    /**
     * GravityRD.Cookie API class.
     * Responsible for:
     * - session cookie handling
     * - page cookie handling
     * - tracking cookie handling
     * - debug cookie handling
     * - provide random seed
     * - serialize and deserialize internal queues of the framework
     * - recid <--> id mappings for click events, and for showed recommendation
     */

    function GravityRD_Core_Cookie() {
        this.queueEventsTrack = new ClientObject("gr_track");
        this.randomSeed = new RandomSeed("gr_rs");

        this.lastViewedItem = null;
        this.recIdMapping = new RecIdMapping();
        this.recClickMapping = new RecClickMapping("gr_click");
        this.persistentNameValues = new ClientObject("gr_persist");
        this.sessionNameValues = new ClientSessionObject("gr_ps");

        // todo: investigate Illes used to use it...
        // todo: investigate ejb/src/main/java/com/gravityrd/receng/main/analytics/AnalyticsHelper.java
        this.initSessionCookie = function () {
            if (this.getCookie("gr_optout") !== "1") {
                if (GravityRD.Core.getConfig()["trackSession"] === true) {
                    var cookieName = "gr_session";
                    var sid = GravityRD.Cookie.getCookie(cookieName);
                    if (sid === null) {
                        sid = (+new Date().getTime()).toString(16) + "-" + this.createRandomString();
                        GravityRD.Cookie.setCookie(cookieName, sid, false);
                    }
                    GravityRD.Core.setGlobalNameValue('sessionId', sid);
                }
            } else {
                this.setCookie("gr_session", "", 0);
            }
        };

        // todo: investigate Illes used to use it...
        // todo: investigate ejb/src/main/java/com/gravityrd/receng/main/analytics/AnalyticsHelper.java
        this.initPageCookie = function () {
            if (GravityRD.Core.getConfig()["trackPage"] === true) {
                var cookieName = "gr_page";
                var sid = GravityRD.Cookie.getCookie(cookieName);
                if (sid === null) {
                    sid = 0;
                } else {
                    sid = sid * 1 + 1
                }
                GravityRD.Cookie.setCookie(cookieName, "" + sid, false);
                GravityRD.Core.setGlobalNameValue('pageId', sid + "-" + this.randHexWord());
            }
        };

        this.getRandomSeed = function () {
            return this.randomSeed.getRandomSeed();
        };

        this.getDebugCookie = function () {
            var grdebug = this.getCookie('gr_debug');
            var json = JSON.parse(grdebug) || {};
            return json;
        };

        this.setDebugCookie = function (json) {
            var enc = JSON.stringify(json);
            this.setCookie('gr_debug', enc);
        };

        this.queueEvents = function (x, key, overwrite) {
            var k = key || 'events';
            var queue = (!!overwrite) ? [] : (this.queueEventsTrack.getValue(k) || []);
            var nqueue = queue.concat(x);
            GravityRD.Log.debug("queueEvents [" + k + "]", nqueue);
            this.queueEventsTrack.setValue(k, nqueue);
        };

        /**
         *
         * @param key
         * @returns {[]}
         */
        this.dequeueEvents = function (key) {
            var k = key || 'events';
            var ret = this.queueEventsTrack.getValue(k);
            this.queueEventsTrack.setValue(k, []);
            GravityRD.Log.debug("dequeueEvents [" + k + "]", ret);
            return ret;
        };

        this.resolveCookieDomain = function (config, host) {
            var cookieDomainVal = null;
            if (config["cookieDomain"] !== null) {
                var cookieDomain = config["cookieDomain"];
                var cookieDomainVal = null;
                var host = host.replace(/:\d+/, '');

                if (Object.prototype.toString.apply(cookieDomain) === '[object Array]') {
                    for (var i = 0; i < cookieDomain.length; i++) {
                        if (host.indexOf(cookieDomain[i]) > -1) {
                            cookieDomainVal = cookieDomain[i];
                            break;
                        }
                    }
                    if (cookieDomainVal === null) {
                        GravityRD.Log.error("Can't resolve cookiedomain for: " + host);
                    }
                } else if (typeof (cookieDomain) === 'function') {
                    cookieDomainVal = cookieDomain(host);
                } else if (typeof (cookieDomain) === 'string') {
                    var m = cookieDomain.match(/level-(\d+)/);
                    if (cookieDomain.match(/level-(\d+)/) !== null) {
                        var level = +m[1];
                        var ld = host.split('.');
                        var li = ld.length;
                        while (--li >= 0 && --level >= 0) {
                            if (cookieDomainVal === null)
                                cookieDomainVal = ld[li];
                            else
                                cookieDomainVal = ld[li] + '.' + cookieDomainVal;
                        }
                    } else {
                        if (cookieDomain.indexOf('.') > -1) {
                            cookieDomainVal = cookieDomain;
                        } else {
                            GravityRD.Log.error("Unrecognized cookieDomain!");
                        }
                    }
                }
            }
            return cookieDomainVal;
        };

        this.setCookie = function (name, value, expire) {
            if (typeof (expire) === "undefined") {
                expire = +new Date() + 1000 * 60 * 60 * 24 * 365 * 10;
            }
            var config = GravityRD.Core.getConfig();
            var cookie = name + "=" + escape(value) + (expire === false ? "" : ";expires=" + new Date(expire).toUTCString()) + ";path=" + config['cookiePath'] + "";
            var cookieDomainVal = this.resolveCookieDomain(config, document.location.host);
            if (cookieDomainVal !== null) {
                cookie += ";domain=" + cookieDomainVal;
            }
            GravityRD.Log.debug("setCookie: '" + cookie + "'");
            document.cookie = cookie;
        };

        /**
         * @param name
         * @returns {string|null}
         */
        this.getCookie = function (name) {
            var cookie = document.cookie;
            if (cookie.length > 0) {
                var start = cookie.indexOf(name + "=");
                if (start !== -1) {
                    start = start + name.length + 1;
                    var c_end = cookie.indexOf(";", start);
                    if (c_end === -1) {
                        c_end = cookie.length;
                    }
                    return unescape(cookie.substring(start, c_end));
                }
            }
            return null;
        };

        /**
         * todo rename: getOrCreateAndSetCookie()
         * @return {string|*}
         */
        this.getGeneratedCookie = function () {
            var config = GravityRD.Core.getConfig()
            var name = config["cookieName"];
            if (this.getCookie("gr_optout") !== "1") {
                var cId = this.getCookie(name);
                if (cId === null) {
                    var ts = +new Date().getTime();
                    cId = ts.toString(16);
                    cId += "-" + this.createRandomString();
                    this.setCookie(name, cId);
                }
                return cId;
            } else {
                this.setCookie(name, "", 0);
            }
        };

        this.getLastViewedItem = function () {
            return this.lastViewedItem;
        };

        this.registerRecId = function (itemId, recId) {
            this.recIdMapping.registerRecId(itemId, recId);
        };

        this.getRecId = function (itemId) {
            return this.recIdMapping.getRecId(itemId);
        };

        this.registerRecClickId = function (itemId, recId) {
            GravityRD.Log.debug("Registering recId '" + recId + "' for item '" + itemId + "'");
            this.recClickMapping.setValue(itemId, recId);
        };

        this.getRecClickId = function (itemId) {
            return this.recClickMapping.getValue(itemId);
        };

        this.randHexWord = function () {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        };

        this.createRandomString = function () {
            return (this.randHexWord() + this.randHexWord() + this.randHexWord() + this.randHexWord());
        };

        this.addPersistentNameValue = function (name, value) {
            if (value == null) {
                this.persistentNameValues.removeValue(name);
            } else {
                this.persistentNameValues.setValue(name, value);
            }
        };

        this.addSessionNameValue = function (name, value) {
            if (value == null) {
                this.sessionNameValues.removeValue(name);
            } else {
                this.sessionNameValues.setValue(name, value);
            }
        };

        this.getPersistentNameValues = function () {
            return this.persistentNameValues.getAllValues();
        };

        this.getSessionNameValues = function () {
            return this.sessionNameValues.getAllValues();
        };

    }

    GravityRD.Cookie = new GravityRD_Core_Cookie();

})(GravityRD);

(function(GravityRD) {
	'use strict'
	/**
	 * GravityRD.Request API class.
	 *
	 * Responsible for:
	 *  - create request to the backend endpoint
	 */
	function GravityRD_Core_Request() {
		this.nr = 0;

		/**
		 * For Backend Compatibility Reasons it is needed
		 * @param {string} key
		 * @return {string}
		 */
		this.formatNameValue = function (key) {
			return "*" + key;
		};

		/**
		 * Gets the full URL for the jsonp script tag src
		 *
		 * @param {string} servletName
		 * @param  {string} [customerName=undefined] customerName
		 * @return {string}
		 */
		this.getEndpoint = function() {
			var serverName = GravityRD.Core.config.targetServer;
			var customerName = GravityRD.Core.config.partnerId;
			return "https://" + serverName + "/grrec-" + (customerName || config.partnerId) + "-war/JSServlet4";
		};

		/**
		 * - ide a js reszponz hivja vissza magat
		 * @param {{}} result
		 */
		this.useResultCB = function(result) {
		    var rn = result.requestNumber;
		    var rri = []

		    if (result && result.recommendationWrappers) {
				for (var i = 0; i < result.recommendationWrappers.length; i++) {
					rri.push(result.recommendationWrappers[i].recommendationIndex);
				}
		    }

		    var cb = window["GravityRD"]["callback"+rn +"__" + rri.join("_")];
		    if (cb) cb(result);

		}

		/**
		 *
		 * @param {string} endpoint url for the call
		 * @param {string} params GET parameters
		 * @param @param rn
		 * @param rri
		 * review may it have dynamic usage rn and rri is never used
		 */
		this.scriptTagRequest = function(endpoint, params, rn, rri) {
		    var that = this;

		    var script = document.createElement('script');
		    script.type = 'text/javascript';
		    script.id = 'x_'+(that.nr++);

			/**
			 * @returns {Boolean|Number}
			 */
			function isIE () {
				var myNav = navigator.userAgent.toLowerCase();
				return (myNav.indexOf('msie') !== -1) ? parseInt(myNav.split('msie')[1]) : false;
		    }

			// TODO refact needed
		    (function() {
			var lastValue;
			var done = 0;
			var cleanUp = function(i) {
				// script does not have onreadystatechange only the document... maybe some IE oldity?
				script["onreadystatechange"] = script["onload"] = script["onerror"] = null;
				(document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0])
					.removeChild(script)
			}


			if (rri != null) {
			    window["GravityRD"]["callback"+rn +"__" + rri.join("_")] = function(result) {
				lastValue = result;
			    };
			    // Success notifier
			    var notifySuccess = function(json) {
				    if ( !( done++ ) ) {
					    cleanUp();
					    //callIfDefined( successCallback , xOptions , [ json , STR_SUCCESS, xOptions ] );
					    //callIfDefined( completeCallback , xOptions , [ xOptions , STR_SUCCESS ] );
					    //console.log("SUCCESS");
				    }
			    }

			    // Error notifier
			    var notifyError = function(type) {
				    if (!( done++ )) {
					    cleanUp();
					    //callIfDefined( errorCallback , xOptions , [ xOptions , type ] );
					    //callIfDefined( completeCallback , xOptions , [ xOptions , type ] );
					    GravityRD.Core.errorCB(rn, rri);
				    }
			    }


			    if (isIE() && isIE() < 10) {
					script.htmlFor = script.id;
					script.event = "onclick";
			    }

			    script["onload"] = script["onerror"] = function ( result ) {
				    // Test readyState if it exists
				    if (!script["readyState"] || !/i/.test( script["readyState"])) {
					    try {
						    script["onclick"] && script["onclick"]();
					    } catch( _ ) {}
					    result = lastValue;
					    lastValue = 0;
					    result ? notifySuccess(result[0]) : notifyError("error");
				    }
			    };
			}
			//gr.async = !0;
			// Attached event handlers

			script.src = endpoint + "?" + params;
			(document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(script);
		    })();
		};

		/**
		 * @param nameValues
		 * @param {string} name
		 * @param {string[]|string} value
		 */
		this.addNameValue = function(nameValues, name, value) {
 			var wrongAttributes = GravityRD.Core.getConfig()["wrongNameValues"]||[];
 			var foundWrongAttrIndex = wrongAttributes.indexOf(name);
 			if(foundWrongAttrIndex !== -1) throw new Error('Wrong attribute: ' + name);

			if(Array.isArray(value)) {
				if(value.length > 0) {
					var s = "";
					for(var i=0; i < value.length; i++) {
						s += (s === ""? "" : "|")+ _T(value[i]);
					}
					nameValues.push(_T(this.formatNameValue(name)) + ":" + s);
				}
			} else {
				nameValues.push(_T(this.formatNameValue(name)) + ":" + _T(value));
			}
		};

		/**
		 * @param {EventRequestOptions} event
		 * @return {string}
		 */
		this.serializeEvent = function(event) {
			var eventDec = [];
			eventDec.push(_T(this.formatNameValue(event.eventType)));
			eventDec.push(_T(event.itemId));

			var nameValues = [];

			for(var prop in event) {
				if (!event.hasOwnProperty(prop) || typeof(event[prop]) === "function" || prop.indexOf("__") === 0) continue;
				var kl = prop.toLowerCase();
				if("type" === kl || "eventtype" === kl || "itemid" === kl) continue;
				if(event[prop] !== undefined) {
					this.addNameValue(nameValues, prop, event[prop]);
				}
			}

			if(nameValues.length !== 0) {
				eventDec.push("[" + nameValues.join(";") + "]");
			}

			return  eventDec.join(",")
		};

		/**
		 * @param {string|false} [userId] userId
		 * @param {boolean} [addCookie=true] addCookie
		 * @param {boolean} [dontSetCookie=false] dontSetCookie
		 * @return {NameValue[]}
		 */
		this.createGlobalData = function(userId, addCookie, dontSetCookie) {
			if (addCookie === undefined) addCookie = true;
			if (dontSetCookie === undefined) dontSetCookie = false;

			var globalRecoData = [];
			var optout = GravityRD.Cookie.getCookie("gr_optout");
			if (optout === "1") {
			    userId = false;
			    addCookie = false;
			    globalRecoData.push({name:'optout', value: "1"});
			} else {
			    globalRecoData.push({name:'optout', value: "0"});
			}
			var config = GravityRD.Core.getConfig();

			globalRecoData.push({name:'rn', value:GravityRD.Core.getRequestNumber()});

			if (userId) {
				globalRecoData.push({name:'uid', value: _E(userId)});
			}

			if (addCookie) {
				var cookieval = GravityRD.Cookie.getGeneratedCookie();
				globalRecoData.push({name:'cid', value: _E(cookieval)});
			}

			globalRecoData.push({name:'v', value: config["buildSHA"]});

			if (dontSetCookie) {
				globalRecoData.push({name:'dsc', value: 'true'});
			}

			globalRecoData.push({name:'ts', value: (+new Date()/1000 | 0)});
			return globalRecoData;
		};

		/**
		 * Gets a serialized array of EventRequests
		 * @param {EventRequestOptions[]} events
		 * @returns {string[]}
		 */
		this.getSerializedEventRequests = function (events) {
			var eventRequests = [];
			if(events.length !== 0) {
				for (var i = 0; i < events.length; i++) {
					/** @var {EventQueueItem} event */
					var eventCopy = Object.assign({},events[i]);
					eventRequests.push(this.serializeEvent(eventCopy));
				}
			}
			return eventRequests;
		}

		/**
		 * @typedef {{}} SerializedRecommendationResult
		 * @property {RecommendationRequestConfig[]} requests
		 * @property {RecommendationRequestConfig[]} remaining
		 *
		 * @param {RecommendationRequestConfig[]} recommendationRequests
		 * @return {SerializedRecommendationResult}
		 */
		this.getSerializedRecommendationRequests = function (recommendationRequests) {
			var requests = [];
			var remaining = [];
			var self = this;

			recommendationRequests.forEach(function (recRequest) {
				if(recRequest.groupId) {
					if(recRequest.__completed !== true) {
						remaining.push(recRequest);
					} else {
						if(recRequest.groupSeq === 1) {
							var ss = self.serializeRecRequest(recRequest);
							for(var last = recRequest; last.__next !== undefined; last = last.__next) {
								ss += self.serializeRecRequest(last.__next);
							}
							requests.push(ss);
						}
					}
				} else {
					requests.push(self.serializeRecRequest(recRequest));
				}
			});

			return { remaining: remaining, requests: requests};
		}


		/**
		 * Prepares all event, recommendation requests to be sent to the backend endpoint.
		 * @param {ServerConfiguration} config
		 * @param {RequestContext} params
		 * @param {string|undefined} [userId=undefined]
		 */
		this.createRequest = function(config, params, userId) {

			if(this.requestNumber === 0){
				GravityRD.Core.freezeConfig();
			}

			if(config.partnerId === null) {
				throw new Error(GravityRD.Log.errorMessages.GR016);
			}

			var globalRecoData = this.createGlobalData(userId);
			var eventRequests = this.getSerializedEventRequests(params.events);
			var r = this.getSerializedRecommendationRequests(params.recommendationRequests);
			var recommendationRequests = r.requests;
			var remaining = r.remaining;

			GravityRD.Core.saveParams(remaining);

			var endpoint = GravityRD.Request.getEndpoint();
			this.createScriptTagRequests(endpoint, globalRecoData, eventRequests, recommendationRequests);

		}


		/**
		 * @param {RecommendationRequestConfig} rr
		 * @return {string}
		 */
		this.serializeRecRequest = function(rr) {
			var rrDec = [];
			var nameValues = [];

			rrDec.push(rr.recommendationIndex);
			rrDec.push(_T(rr.scenarioId));

			if(rr.templating && rr.templating.serverSide){
                rrDec.push(rr.templating.templateId);
            }

			rrDec.push(_T(rr.numberLimit || 0));

			for(var k in rr) {
				if(!rr.hasOwnProperty(k) || k.indexOf("__") === 0 || typeof(rr[k]) === "function") continue;
				var kl = k.toLowerCase();
				if("recommendationindex" === kl || "type" === kl || "scenarioid" === kl
					|| "numberlimit" === kl || "templating" === kl|| "resultnames" === kl
					|| "callback" === kl)
					continue;
				this.addNameValue(nameValues, k, rr[k]);
			}
			rrDec.push((nameValues.length > 0) ? "[" + nameValues.join(";") + "]" : "");
			rrDec.push( "[" + _TA(rr.resultNames) + "]" );

			return rr.templating && rr.templating.serverSide
				? "&rs=" + rrDec.join(",")
				: "&rd=" + rrDec.join(",");
		}



		/**
		 * Split the request into multiple parts, so each subrequest is smaller than 2048 bytes if possible.
		 * @param {string} endpoint
		 * @param {NameValue[]} globalRecoData
		 * @param {string[]} eventRequests
		 * @param {string[]} recommendationRequests
		 */
		this.createScriptTagRequests = function(endpoint, globalRecoData, eventRequests,
												recommendationRequests) {
			var queryLimit = 2048 - 5 /*indicating truncate*/ - 11 /*random identifier per request*/;

			var gParms = [];
			for(var i=0; i < globalRecoData.length; i++) {
				gParms.push(globalRecoData[i].name+"="+globalRecoData[i].value);
			}
			var baseUrl = gParms.join("&");
			var maxRun = recommendationRequests.length + eventRequests.length;

			while(recommendationRequests.length !== 0 || eventRequests.length !== 0) {
				if(maxRun-- < 0) {
					GravityRD.Log.error("Possible infinite loop");
					break;
				}

				var src = baseUrl;
				var hadEvent = false;

				if(eventRequests.length > 0) {
					hadEvent = true;
					if((eventRequests[0].length+3) > (queryLimit - src.length)) {
						src += "&e=" + eventRequests[0];
						eventRequests = eventRequests.slice(1);
						src += "&tr=1";
						GravityRD.Log.error("Query limit is too small to push event request");
						this.loadScripts(endpoint, src, null);
						continue;
					} else {
						while(eventRequests.length > 0 && (eventRequests[0].length+3) < (queryLimit - src.length)) {
							src += "&e=" + eventRequests[0];
							eventRequests = eventRequests.slice(1);
						}
					}
				}

				var rri = []

				if(recommendationRequests.length > 0) {
					var recommendationRequestStr = recommendationRequests[0];

					if((recommendationRequests[0].length+4) >= (queryLimit - src.length)) {
						if(hadEvent) {
							GravityRD.Log.debug("Pushing events");
							this.loadScripts(endpoint, src, null);
							continue;
						}
						src += recommendationRequestStr;
						// rs=0
						rri.push(recommendationRequestStr.split(",")[0].split("=")[1])
						var remaining = queryLimit - src.length-4;
						src += "&tr=2";
						recommendationRequests = recommendationRequests.slice(1);
						GravityRD.Log.error("Query limit is too small to push recommendation request");
						this.loadScripts(endpoint, src, rri);
						rri = []
						continue;
					} else {
						while(recommendationRequests.length > 0 && (recommendationRequests[0].length+4) < (queryLimit - src.length)) {
							recommendationRequestStr = recommendationRequests[0];
							src += recommendationRequestStr;
							rri.push(recommendationRequestStr.split(",")[0].split("=")[1])
							recommendationRequests = recommendationRequests.slice(1);
						}
					}
				}

				this.loadScripts(endpoint, src, rri);
			}
		}

		/**
		 * Create the actual request using script-tag jsonp.
		 * @param {string} endpoint
		 * @param {string} url
		 * @param {string[]} rri
		 */
		this.loadScripts = function(endpoint, url, rri) {
			GravityRD.Log.group("LoadScripts " + endpoint, true);
			url.replace(/([^&]+)&?/g, function(_, p) {
				GravityRD.Log.debug(p);
			});
			GravityRD.Request.scriptTagRequest(endpoint, url + "&r=" + GravityRD.Cookie.randHexWord()+GravityRD.Cookie.randHexWord(), GravityRD.Core.getRequestNumber()-1, rri);
			GravityRD.Log.groupEnd();
		}
	}

	/**
	 * @param {*} value
	 * @returns {string|null}
	 * @private
	 */
	function _T(value) {
		if (value === null || value === undefined) return null;
		var string = value.toString()
			.replace(/-/g, "-0")
			.replace(/,/g, "-1")
			.replace(/;/g, "-2")
			.replace(/\[/g,"-3")
			.replace(/\]/g,"-4")
			.replace(/:/g,"-5")
			.replace(/\|/g,"-6");

		return _E(string);
	}

	function _E (string) {
		return encodeURIComponent(string);
	}

	/**
	 * @param {[]}arr
	 * @returns {string}
	 * @private
	 */
	function _TA(arr) {
		var resultNamesEnc = [];
		for(var i=0; i < (arr||[]).length; i++) {
			resultNamesEnc.push(_T(arr[i]));
		}
		return resultNamesEnc.join(";");
	}

		GravityRD.Request = new GravityRD_Core_Request();
})(GravityRD);


(function (GravityRD) {
	'use strict';

	/**
	 * @interface IMatcher
	 */

	/**
	 * Matches
	 *
	 * @method match
	 * @name IMatcher#match
	 * @return {boolean}
	 */

	/**
	 * Registers
	 *
	 * @method
	 * @name  IMatcher#register
	 */


	/**
	 * Abstract regexp matcher class. It can automatically register groups in regexp.
	 * Subclasses need to provide the input on which the matcher will be evaluated.
	 * @class RegexpMatcher
	 * @implements {IMatcher}
	 * @constructor
	 * @param {TypedObject} c
	 *
	 */
	function RegexpMatcher(c) {
		this.config = c;
		this.matchoutput;
	}

	RegexpMatcher.prototype.match = function () {
		var input = this.getInput();
		var pattern = new RegExp(this.config.pattern);
		this.matchoutput = pattern.exec(input);
		return !!this.matchoutput;
	};

	RegexpMatcher.prototype.register = function () {
		if (this.match()) {
			if (!!this.matchoutput) {
				var register = this.config.registerGroup || this.config.register;
				if (!!register) {
					for (var i = 1; i < this.matchoutput.length; i++) {
						if (!!register[i]) {
							var key = GravityRD.Utils.isObject(register[i]) && GravityRD.Utils.isString(register[i].key) ? register[i].key : register[i];
							var value = GravityRD.Utils.isObject(register[i]) && GravityRD.Utils.isFunction(register[i].formatter) ? register[i].formatter(this.matchoutput[i]) : this.matchoutput[i];
							GravityRD.Core.setGlobalNameValue(key, value);
						}
					}
					if (!!register[0]) {
						GravityRD.Core.setGlobalNameValue(register[0], 'true');
					}
				}
			}
		}
	};
	RegexpMatcher.prototype.getInput = function () {
		return "";
	}

	function URLPathRegexpMatcher(c) {
		this.config = c;
	}

	URLPathRegexpMatcher.prototype.getInput = function () {
		return document.location.pathname;
	}

	GravityRD.Utils.extend(URLPathRegexpMatcher, RegexpMatcher);

	function HostRegexpMatcher(config) {
		this.config = config;
	}

	HostRegexpMatcher.prototype.getInput = function () {
		return document.location.host;
	}

	GravityRD.Utils.extend(HostRegexpMatcher, RegexpMatcher);

	function URLRegexpMatcher(config) {
		this.config = config;
	}

	URLRegexpMatcher.prototype.getInput = function () {
		return document.location.href;
	}

	GravityRD.Utils.extend(URLRegexpMatcher, RegexpMatcher);

	function URLQueryRegexpMatcher(config) {
		this.config = config;
	}

	URLQueryRegexpMatcher.prototype.getInput = function () {
		var s = document.location.search;
		try {
			return decodeURIComponent(s);
		} catch (e) { // fallback
			try {
				return decodeURI(s);
			} catch(e){
				return unescape(s);
			}
		}
	};

	GravityRD.Utils.extend(URLQueryRegexpMatcher, RegexpMatcher);

	function CookieRegexpMatcher(config) {
		this.config = config;
	}

	CookieRegexpMatcher.prototype.getInput = function () {
		return GravityRD.Cookie.getCookie(this.config.cookieName);
	}

	GravityRD.Utils.extend(CookieRegexpMatcher, RegexpMatcher);
	
	function ReferrerRegexpMatcher(config) {
		this.config = config;
	}

	ReferrerRegexpMatcher.prototype.getInput = function () {
		return document.referrer;
	}

	GravityRD.Utils.extend(ReferrerRegexpMatcher, RegexpMatcher);


	/**
	 * @implements IMatcher
	 * @constructor
	 * @param {{matcher: PredicateMatcher~matcher, register:PredicateMatcher~register}} c
	 */
	function PredicateMatcher(c) {
		this.config = c;
		this._matcherFn = null;
		this._registerFn = null;
		/**
		 * @param {*} fn
		 * @returns {null|Function}
		 * @throws
		 */
		this.parsePredicates = function (fn) {
			if (fn == null) {
				return null;
			} else if (GravityRD.Utils.isFunction(fn)) {
				return fn;
			} else if (GravityRD.Utils.isString(fn)) {
				try{
					return new Function("return " + JSON.parse(fn))();
				}catch (e){
					return new Function("return " + fn)();
				}
			} else {
				throw new Error("matcher Function cannot be applied");
			}
		};
		/**
		 * @returns {null|Function}
		 */
		this.getMatcher = function () {
			if (!this._matcherFn) {
				this._matcherFn = this.parsePredicates(this.config.matcher);
			}
			return this._matcherFn;
		};
		/**
		 * @returns {null|Function}
		 */
		this.getRegister = function () {
			if (!this._registerFn) {
				this._registerFn = this.parsePredicates(this.config.register);
			}
			return this._registerFn;
		}
		/**
		 * @returns {boolean}
		 */
		this.match = function () {
			var matcherFn = this.getMatcher();
			return matcherFn != null ? matcherFn.call() : false;
		}
		this.register = function () {
			var registerFn = this.getRegister();
			if (registerFn) {
				var data = GravityRD.Core.makeValueListDict();
				registerFn.call(null, data);
				GravityRD.Core.globalNameValues.mergeInFrom(data);
			}
		}
	}
	/**
	 * This callback is displayed as part of the Requester class.
	 * @callback PredicateMatcher~matcher
	 * @return {boolean}
	 */

	/**
	 * This callback is displayed as part of the Requester class.
	 * @callback PredicateMatcher~register
	 * @param {StringValueListDictionary} data
	 */

	/**
	 * @implements IMatcher
	 * @param {{matchProps:[], registerProps:{
	 *     "itemId":["kukucs","maci"]
	 * }}} c
	 * @constructor
	 */
	function JsonSchemaScriptMatcher(c) {
		this.config = c;
		/**
		 * @param {string[]} jsons
		 * @param {string[]} props
		 * @param {boolean} [takeOnlyFirst=false] takeOnlyFirst
		 * @return {[]}
		 */
		this.detect = function (jsons, props, takeOnlyFirst) {
			takeOnlyFirst = takeOnlyFirst || false;
			var data = [];
			for(var i in jsons){
				if(!jsons.hasOwnProperty(i)) continue;
				var json = jsons[i];
				try{
					var obj = JSON.parse(json);
					for(var j in props){
						var propExpr = props[j];
						var path = propExpr.split("+");
						var value = this._getValue(path, obj);
						if(value){
							data.push(value);
							if(takeOnlyFirst) return data;
						}

					}
				}catch(e){
				}
			}
			return data;
		}
		/**
		 * @param {[]} arr
		 * @param {{}} obj
		 * @private
		 */
		this._getValue = function (arr, obj) {
			var first = arr.shift();
			if(arr.length === 0){
				return obj.hasOwnProperty(first) ? obj[first] : undefined;
			}
			if(obj.hasOwnProperty(first) && obj[first] !== null && typeof obj[first] === "object"){
				return this._getValue(arr, obj[first]);
			}
			return undefined;
		}
		this.findJsonSchemasInnerText = function () {
			var tags = document.querySelectorAll("script[type='application/ld+json']");
			var result = [];
			for(var i in tags){
				if(!tags.hasOwnProperty(i)) continue;
				result.push(tags[i].innerText);
			}
			return result;
		}
		this._match = function (jsons) {
			return this.detect(jsons, this.config.matchProps, true).length > 0;
		}
		this.match = function () {
			var jsons = this.findJsonSchemasInnerText();
			return this._match(jsons);
		}
		this._register = function (jsons) {
			for(var i in this.config.registerProps){
				if(!this.config.registerProps.hasOwnProperty(i)) continue;
				var extractedData = this.detect(jsons,this.config.registerProps[i]);
				GravityRD.Core.addGlobalNameValue(i,extractedData);
			}
		}
		this.register = function () {
			var jsons = this.findJsonSchemasInnerText();
			this._register(jsons);
		}
	}
	
	/**
	 * CSS selector based matcher. If the given selector exists it returns a match.
	 * Can register different css selector based values.
	 */
	function SelectorMatcher(c) {
		this.config = c;
		this.match = function () {
			return document.querySelectorAll(this.config.selector).length > 0;
		};
		this.register = function () {
			if (this.match()) {
				var register = this.config.register || {};
				var regTmp = {};
				for (var key in register) {
					if (!register.hasOwnProperty(key)) continue;
						var formatter;
						var exp;
						if (GravityRD.Utils.isObject(register[key])) {
							exp = register[key].value;
							formatter = register[key].formatter;
						} else {
							exp = register[key];
						}
						var val = exp.split("::");
						var regNodeList = document.querySelectorAll(val[0]);
						regNodeList.forEach(function (item) {
							regTmp[key] = regTmp[key] || [];
							var value = null;
							if (val[1] === "text()") {
								value = item.childNodes[0].nodeValue;
							} else if (val[1] === "number()") {
								var childNodesLength = item.childNodes.length;
								var i = 0;
								var notFound = true;
								while(notFound && i < childNodesLength) {
									if(item.childNodes[i].nodeValue !== null) {
										value = item.childNodes[i].nodeValue.replace(/\s/g, "");
										if (value !== null) {
											var regex = /([0-9]+)([.,\s][0-9]+)?/;
											var groups = regex.exec(value);
											if (groups && groups.length > 0) {
												value = groups[0];
												notFound = false;
											} else {
												value = null;
											}
											if (value !== null) {
												var delimiterChar = value.indexOf(".") > -1 ? "." : value.indexOf(",") > -1 ? "," : null;
												if (delimiterChar && (value.length - 1) - value.indexOf(delimiterChar) > 2) {
													value = value.replace(/[.,]/g, "");
												}
											}
										}
									}
									i++;
								}
							} else if (val[1] === "content()") {
								value = item.innerHTML.replace(/<script\b[^>]*>([\s\S]*?)<\/script>/gmi, "");
								value = value
									.replace(/<[^>]*>/g, "")
									.trim()
									.replace(/\s{2,}/g, " ");
							} else {
								value = item[val[1]];
							}
							if(value !== null) {
								if (GravityRD.Utils.isFunction(formatter)) value = formatter(value);
								regTmp[key].push(value);
							}
						});
				}
				for (var prop in regTmp) {
					if (regTmp.hasOwnProperty(prop) && regTmp[prop] && regTmp[prop].length > 0) {
						GravityRD.Core.setGlobalNameValue(prop, regTmp[prop]);
					}
				}
			}
		}
	}

	/**
	 * Can match and register 'meta' tags.
	 */
	function MetaTagMatcher(config) {
		this.config = config;
		this.match = function () {
			var metaTags = document.getElementsByTagName('meta');
			for (var i = 0; i < metaTags.length; i++) {
				if (metaTags[i].name === this.config.varname) {
					this.value = metaTags[i].content;
					return true;
				}
			}
			return false;
		};
		this.register = function () {
			if (this.config.register) {
				var register = this.config.register || {};
				var regTmp = {};
				if (this.match()) {
					for (var key in register) {
						if (!register.hasOwnProperty(key)) {
							continue;
						}
						if (typeof (key) == "string") {
							var formatter;
							if (GravityRD.Utils.isObject(register[key])) {
								formatter = register[key].formatter;
							} else {
								formatter = register[key];
							}
							regTmp[key] = regTmp[key] || [];
							var value;
							if (GravityRD.Utils.isFunction(formatter)) {
								value = formatter(this.value);
							} else {
								value = this.value;
							}
							regTmp[key].push(value);
						}
					}
				}
				for (key in regTmp) {
					if (typeof (key) == "string") {
						if (regTmp[key] !== undefined && regTmp[key].length > 0) {
							GravityRD.Core.setGlobalNameValue(key, regTmp[key]);
						}
					}
				}
			}
		}
	}

	/** predefined renaming strategies for the MetaDataMatcher (it registers multiple values at the same time) */
	var renamingStrategy = {
		/**
		 * common renaming strategy for html based information
		 * <div current-item-id=12> -> currentItemId: 12
		 */
		camelcase: function (input) {
			var ia = input.split('-');
			var ret = ia[0];
			for (var i = 1; i < ia.length; i++) {
				ret += ia[i].substring(0, 1).toUpperCase();
				ret += ia[i].substring(1);
			}
			return ret;
		},
		identity: function (input) {
			return input;
		}
	};
	
	/**
	 * Special type of selector matcher, which can match configuration divs:
	 * <div id="gravity-data">
	 *  <div data-name="page-type" data-value="ITEMPAGE"/>
	 *  <div data-name="user-id" data-value="12"/>
	 *  <div data-name="item-id" data-value="12345"/>
	 * </div>
	 * Additionally this matcher is able to create a hash of the parameters and register it as a global namevalue.
	 * This can be used in online addItem implementation.
	 * */
	function MetaDataMatcher(config) {
		this.config = config;
		this.register = function () {
			if (this.match()) {
				var rename = this.config.renamingStrategy || 'camelcase';
				if (!GravityRD.Utils.isFunction(rename)) {
					rename = renamingStrategy[rename];
					if (!rename) {
						GravityRD.Log.error("Invalid renamingStrategy specified!");
					}
				}
				var register = this.config.register || {};
				var rh = this.config.registerHash;
				rh = rh === true ? "_Hash" : rh;
				var nv = {};
				var self = this;
				this.nodelist.forEach(function (element) {
					element.getElementsByTagName('*').forEach(function (node) {
						var bnode = self.$(node);
						var name = bnode.data('name');
						var value = bnode.data('value');
						if (nv[name] === undefined) {
							nv[name] = [];
						}
						nv[name].push(value);
						if (register === true) {
							GravityRD.Core.addGlobalNameValue(rename(name), value);
						} else if (register[name] !== undefined) {
							if (register[name] === true) {
								name = rename(name);
							} else {
								name = register[name];
							}
							GravityRD.Core.addGlobalNameValue(name, value);
						}
					});
				});
				if (rh) {
					var hash = GravityRD.Utils.hash(nv);
					GravityRD.Core.addGlobalNameValue(rh, "" + hash);
				}
			}
		}
	}

	GravityRD.Utils.extend(MetaDataMatcher, SelectorMatcher);



	/**
	 * Extract referral campaigns and keywords supplied for Google Analytics
	 *
	 * @typedef {TypedObject} UTMMatcherConfig
	 *
	 *
	 * @param {UTMMatcherConfig} config
	 *
	 * Parameters:
	 * - config.source: source of Google Analytics (UTM) referral data
	 *    * "referrer": parse referrer URL (useful when behind redirect)
	 *    * "location": parse location URL (for most cases)
	 *    * "utmcookie": parse utm cookie (when no others work, supply name of UTM cookie in "utmcookie", default: "__utmz")
	 * - config.register.keyword: extract referrer keyword (aka term)
	 * - config.register.campaign: extract referrer campaign
	 */
	function UTMMatcher(config) {
		config.type
		this.config = config;
		this.match = function () {
			return true;
		};
		this.register = function () {
			var self = this;
			this.config.source.forEach(function (sc) {
				var paramMap = null;
				if (sc.type === 'referrer') {
					paramMap = self.parseUrlParams("" + document.referrer);
				} else if (sc.type === 'location') {
					paramMap = self.parseUrlParams("" + document.location);
				} else if (sc.type === 'utmcookie') {
					var cookieVal = GravityRD.Cookie.getCookie(self.config.utmcookie || "__utmz");
					paramMap = self.parseUTMCookieParams(cookieVal);
				} else {
					GravityRD.Log.error("Unknown source type specified: '" + sc.type + "'");
				}
				//pk_* params: http://piwik.org/docs/tracking-campaigns/
				//self.config.register.campaign === true ?
				var cn = self.config.register.campaign;
				if (!!cn) {
					var campaign = paramMap["utm_campaign"] || paramMap["utmccn"] || paramMap["utm_medium"] || paramMap["utmcmd"] || paramMap["utm_source"] || paramMap["utmcsr"] || paramMap["pk_campaign"];
					if (!!campaign) {
						GravityRD.Core.addGlobalNameValue(cn === true ? '_Campaign' : cn, campaign);
					}
				}
				var kw = self.config.register.keyword;
				if (!!kw) {
					var keyword = paramMap["utm_term"] || paramMap["utmctr"] || paramMap["pk_keyword"];
					if (!!keyword) {
						GravityRD.Core.addGlobalNameValue(kw === true ? '_Keyword' : kw, keyword);
					}
				}
				//utm_content, utmccn -- not used currently
				//http://support.google.com/analytics/answer/1033867?hl=en
			});
		};
		
		this.parseUrlParams = function (input) {
			var ret = {};
			if (input != null) {
				input.replace(/.*\?/, "").replace(/([^=]+)=([^#&]*)&?/g, function (_, a, b) {
					ret[decodeURIComponent(a)] = decodeURIComponent(b);
				});
			}
			return ret;
		};
		
		this.parseUTMCookieParams = function (input) {
			var ret = {};
			if (input != null) {
				input.replace(/(utmc[^=]+)=([^|]*)/g, function (_, a, b) {
					ret[decodeURIComponent(a)] = decodeURIComponent(b);
				});
			}
			return ret;
		};
	}

	var matcherFactory = {
		/**
		 *
		 * @param {TypedObject} config
		 * @return {IMatcher}
		 */
		getInstance: function (config) {
			var type = config.type;
			if ("urlpath-regexp" === type) {
				return new URLPathRegexpMatcher(config);
			} else if ("url-regexp" === type) {
				return new URLRegexpMatcher(config);
			} else if ("urlquery-regexp" === type) {
				return new URLQueryRegexpMatcher(config);
			} else if ("host-regexp" === type) {
				return new HostRegexpMatcher(config);
			} else if ("cookie-regexp" === type) {
				return new CookieRegexpMatcher(config);
			} else if ("referrer-regexp" === type) {
				return new ReferrerRegexpMatcher(config);
			} else if ("selector" === type) {
				return new SelectorMatcher(config);
			} else if ("meta-tag" === type) {
				return new MetaTagMatcher(config);
			} else if ("meta-data" === type) {
				return new MetaDataMatcher(config);
			} else if ("utm" === type) {
				return new UTMMatcher(config);
			} else if ("jsonschema" === type) {
				return new JsonSchemaScriptMatcher(config);
			} else if ("predicate" === type) {
				return new PredicateMatcher(config);
			} else {
				GravityRD.Log.error("Unknown matcher type '" + type + "', please check your configuration");
				return null;
			}
		}
	};


	/**
	 * 	{pages: {}, templates: {}};
	 * 	@typedef CustomConfigOptions
	 * 	@param {{}} pages
	 * 	@param {{}} templates
	 */


	/**
	 * GravityRD.CustomConfig API class. It is reponsible to initialize and apply customconfig configuration.
	 * See documentation at function level.
	 */
	function CustomConfig() {
		this.matcherFactory = matcherFactory;
		/**
		 * @type {CustomConfigOptions|null}
		 */
		this.config= null;
		this.initialized= false;
		this.initCallbacks= [];
		this.initCallbacksRan= false;

		/**
		 *
		 * @param {CustomConfigOptions} config
		 * @param environment
		 */
		this.set = function (config, environment) {
			this.config = config;
			this.environment = environment;
			// todo fire CustomConfigOptions was set....
		};

		/**
		 * Functions specified through this interface are executed at customconfig init before applying
		 * the custom configuration.
		 * @param {[]<Function>} fns
		 * @param {Boolean} immediate
		 */
		this.addInitCallback = function (fns, immediate) {
			var self = this;
			if (immediate) {
				fns.forEach(function (fn) {
					// todo: do we have to capture this?
					fn.apply(self);
				});
			} else {
				fns.forEach(function (fn) {
					self.initCallbacks.push(fn);
				});
			}
		};

		/**
		 * Utility function to apply custom css style on the fly
		 * @param {string[]} css
		 */
		this.applyCss = function (css) {
			// var st = this.styleTag = document.createElement("style");
			var st = document.createElement("style");
			var cssx = "";

			st.type = "text/css";
			st.media = "screen, projection";

			
			css.forEach(function (line) {
				cssx += line + "\n";
			});
			if (st.styleSheet) {
				st.styleSheet.cssText += "\n" + cssx;
			} else {
				st.appendChild(document.createTextNode(cssx));
			}
			document.getElementsByTagName("head")[0].appendChild(st);
		};


		/**
		 * Initialize apply custom configuration
		 */
		this.init = function () {
			var self = this;

			if (!this.initCallbacksRan) {
				this.initCallbacks.forEach(function (fn) {
					fn.call(self);
				});
				this.initCallbacksRan = true;
			}

			if (this.config == null) return;
			
			this.pageName = this.identifyPage();
			GravityRD.Log.debug("Page identification: '" + this.pageName + "'");

			if (this.pageName == null) return;
			GravityRD.Core.setGlobalNameValue('_Page', this.pageName);
			// var config = this.initSplit(this.pageName, this.config.pages[this.pageName]);
			var config = this.config.pages[this.pageName];

			if(config.register) {
				config.register.forEach(function (conf) {
					var matcher = self.matcherFactory.getInstance(conf);
					matcher.register();
				});
			}

			if(Array.isArray(config.applyCss) && config.applyCss.length > 0){
				GravityRD.CustomConfig.applyCss(config.applyCss);
			}

			/** @var {Function} pageController */
			var pageController = config['pageController'] || config['postRenderFunction'];
			if(pageController){
				GravityRD.Log.debug("Executing pageController");
				try {
					var gravity = window._gravity || [];
					var gv = GravityRD.Core.globalNameValues;
					var itemId = gv.itemId || gv.ItemId;
					pageController.call(null, gravity, gv, itemId);
					// todo: fire pageController handled
				} catch (e) {
					// todo: fire error callback
					GravityRD.Log.error("Exception while executing postRenderFunctions", e);
				}
			}
			// todo: fire custom config init was done
		};
		/**
		 * todo> donno stays or goes... will see
		 * Calculate the order of pages, in which order we try to match the regexp
		 * @return {string[]}
		 */
		this.calcPageOrder = function (pages) {
			/** pageOrder defines the order string list */
			var pageOrderConfig = this.config.pageOrder || [];
			var pageDisableConfig = this.config.pageDisable || [];
			var pageNames = {};
			var pageOrder = [];
			
			for (var pageName in pages) {
				if (!pages.hasOwnProperty(pageName)) {
					continue;
				}
				if (GravityRD.Utils.isString(pageName)) {
					pageNames[pageName] = !0;
				}
			}
			for (var i = 0; i < pageDisableConfig.length; i++) {
				delete pageNames[pageDisableConfig[i]];
			}
			for (i = 0; i < pageOrderConfig.length; i++) {
				if (pageNames[pageOrderConfig[i]]) {
					delete pageNames[pageOrderConfig[i]];
					pageOrder.push(pageOrderConfig[i]);
				}
			}
			for (pageName in pageNames) {
				if (!pages.hasOwnProperty(pageName)) {
					continue;
				}
				if (GravityRD.Utils.isString(pageName)) {
					pageOrder.push(pageName);
				}
			}
			return pageOrder;
		};
		/** Determine what is the underlying page */
		this.identifyPage = function () {
			GravityRD.Log.group("Pages identification", true);
			var pages = this.config.pages || {};
			var pageOrder = this.calcPageOrder(pages);

			for (var j = 0; j < pageOrder.length; j++) {
				var pageName = pageOrder[j];
				GravityRD.Log.group(pageName);
				var page = this.config.pages[pageName];
				var matchType = page.matchType || 'all'; // all vagz any
				var matcher;
				var matched = matchType === 'all';
				if (Array.isArray(page.match)) {

					for (var i = 0; i < page.match.length; i++) {
						matcher = this.matcherFactory.getInstance(page.match[i]);
						var matcherType = page.match[i].type;
						var m = matcher.match();
						if (m && matchType === 'any') {
							matched = true;
							GravityRD.Log.debug(matcherType + " matched(*): TRUE", page.match[i]);
							break;
						} else if (!m && matchType === 'all') {
							matched = false;
							GravityRD.Log.debug(matcherType + " matched(*): FALSE", page.match[i]);
							break;
						}
						GravityRD.Log.debug(matcherType + " matched: " + (!!m ? "TRUE" : "FALSE"), page.match[i]);
					}

				} else {
					if(!page.hasOwnProperty("match")){
						matched = false;
						GravityRD.Log.debug("No matcher was provided for: " + pageName);
					}else{
						matcher = this.matcherFactory.getInstance(page["match"]);
						matched = matcher.match();

						if(!matched)
							GravityRD.Log.debug(page.match.type + " didn't match ", page["match"]);
					}

				}
				GravityRD.Log.groupEnd();
				if (matched) {
					var self = this;
					GravityRD.Log.groupEnd();
					page.match.forEach(function (conf) {
						var matcher = self.matcherFactory.getInstance(conf);
						matcher.register();
					});
					return pageName;
				}
			}
			GravityRD.Log.groupEnd();
			return null;
		};
	}

	GravityRD.CustomConfig = new CustomConfig();

	if(TEST){
		GravityRD.CustomConfig.JsonSchemaScriptMatcher = JsonSchemaScriptMatcher;
		GravityRD.CustomConfig.PredicateMatcher = PredicateMatcher;
	}

})(GravityRD);
(function (GravityRD) {
    'use strict'
    /** Predefined list of possible error messages. */
    var errorMessages = {
        "GR001": "Attribute '#1#' should have '#2#' type",
        "GR002": "Dom element with id '#1#' not found",
        "GR003": "Attribute '#1#' shouldn't be null",
        "GR007": "Invalid push item specified: '#1#'. Parameters to push() should have object type",
        "GR008": "Invalid type attribute in push item specified: '#1#'. Possible candidates: [#2#]",
        "GR010": "Missing mandatory parameter: '#1#'. Push object: '#2#'",
        "GR011": "Invalid attribute in push item specified: '#1#'. Possible candidates: [#2#]",
        "GR012": "Either 'templating' or 'callback' attribute should be specified in recommendation push object",
        "GR013": "Both template and templateElementId specified",
        "GR014": "Neither template nor templateElementId specified",
        "GR015": "Initializing of templates failed",
        "GR016": "Please configure the 'partnerId'",
        "GR019": "You don't have enough privileges to access this function",
        "GR020": "Array parameter [#1#] should have at least one element.",
        "GR021": "The value [#1#] for attribute '#2#' is suspicious. If you are sure it is valid, please contact us, to disable this feature!",
        "GR023": "No 'groupSeq' attribute defined for group [#1#]",
        "GR024": "No 'groupSize' attribute defined for group [#1#]",
        "GR025": "Invalid 'groupSequence' attribute specified for group [#1#]. Got: #2#, expected: [#3#]}",
        "GR026": "Invalid 'groupSize' attribute specified for group [#1#], groupSize: [#2#]",
        "GR027": "Invalid 'groupSize' attribute specified for group [#1#], groupSize: [#2#], expected: [#3#]",
        "GR028": "Exception thrown by template rendering: '#1#'",
        "GR029": "Loading the javascript framework from this domain is not allowed",
        "GR030": "Server side and client side template rendering is not allowed on the same recommendation. (Use template or templateId, but not both)."
    };

    /**
     * GravityRD.Log API class.
     *
     * Default console logger implementation. It supports an advanced logging and console interface, and if the underlying console doesn't support those (IE ofc), then emulates its behavior.
     */
    function Log() {
        this.prefixes = [];
        this.errorMessages = errorMessages;

        this.debug = function (msg, obj) {
            if (GravityRD.Core.getConfig()["mode"] === 'DEVELOP') {
                if (obj !== undefined) {
                    console.log(this.prefix() + msg, obj);
                } else {
                    console.log(this.prefix() + msg);
                }

            }
        }

        this.group = function (groupName, collapsed) {
            if (collapsed === true) {
                console.groupCollapsed(groupName);
            } else {
                console.group(groupName);
            }
        }

        this.prefix = function () {
            return this.prefixes.join("::") + "::";
        }

        this.groupEnd = function () {
            console.groupEnd();
        }

        this.info = function (msg, obj) {
            if (obj !== undefined) {
                console.info(this.prefix() + msg, obj);
            } else {
                console.info(this.prefix() + msg);
            }
        }

        this.error = function (msg, obj) {
            if (obj) {
                console.error(this.prefix() + msg, obj);
            } else {
                console.error(this.prefix() + msg);
            }
        }

        // this.timeStamp removed because of this: https://developer.mozilla.org/en-US/docs/Web/API/Console/timeStamp

        // marad
        this.time = function (str) {
            console.time(str);
        }

        // marad
        this.timeEnd = function (str) {
            console.timeEnd(str);
        }
    }

    GravityRD.Log = new Log();
})(GravityRD);
(function(GravityRD) {
	'use strict'
	/**
	 * This class is responsible for group and debounce the calls which it receives through it's push interface.
	 * The defering happens when the interpreters callstack becomes empty (@see setTimeout(0)).
	 */
	function GravityRD_Worker_PushProcessor() {
		this.handle = null;
		this.equeue = [];
		this.queue = [];
		this.lastHash = -1;

		/**
		 * @param {{}} parm
		 * @param {boolean} sync
		 */
		this.push = function (parm, sync) {
			GravityRD.Log.debug('Push request:', parm);

			if (parm.type === 'event') {
				var hash = GravityRD.Utils.hash(parm);
				if (hash === this.lastHash) {
					GravityRD.Log.debug("Suppressed event because it has the same hash as the previous event", parm);
					return;
				}
				this.lastHash = hash;
				parm._ts = +new Date()/1000 | 0;
			}


			if (parm.type === 'event') {
				this.equeue.push(parm);
				GravityRD.Cookie.queueEvents(this.equeue, 'push', true);
			} else {
				this.queue.push(parm);
			}

			this.schedule();
		}

		this.process = function() {
			this.handle = null;
			GravityRD.Log.group("Process queue");
			for (var i=0; i < this.queue.length; i++) {
				GravityRD.Log.debug('' + i, this.queue[i]);
			}
			GravityRD.Log.groupEnd();
			var fromCookie = GravityRD.Cookie.dequeueEvents('push') || [];
			GravityRD.Core.process((this.queue||[]).concat(fromCookie));
			this.equeue = [];
			this.queue = [];
		}

		this.schedule = function() {
			this.clearPending();
			this.handle = window.setTimeout(this.process.bind(this), 0);
		}

		this.clearPending = function() {
			if(this.handle !== null) {
				window.clearTimeout(this.handle);
			}
		}
	}

	var pushProcessor = new GravityRD_Worker_PushProcessor();

	/**
	 * GravityRD.Worker API class. It's main responsibility to initialize its framework:
	 *   - process calls which were queued before the framework was initialized
	 *   - install the push processor
	 *   - initialize  custom configuration
	 *   - initialize HUD (if present)
	 *   - initialize debug hashmarks options
	 *   - initalize page and session cookies
	 */
	function Worker(){
		this.installPushProcessor = function() {
			window._gravity = pushProcessor;
			pushProcessor.schedule();
			GravityRD.Log.debug("Push processor installed");
		}

		this.processInitialArray = function() {
			for(var i=0; i < window._gravity.length; i++) {
				var item = window._gravity[i]
				pushProcessor.push(item, false);
			}
			GravityRD.Log.debug("Initial array processed");
		}


		this.start = function() {
			window._gravity = window._gravity || [];

			if (!Array.isArray(window._gravity)) {
				GravityRD.Log.debug("Framework already initialized");
				return false;
			}

			var pnv = GravityRD.Cookie.getPersistentNameValues();

			Object.keys(pnv).forEach(function(k) {
				GravityRD.Log.debug("Loading persistent namevalue: " + k, pnv[k]);
				GravityRD.Core.addGlobalNameValue(k, pnv[k],true, false);
			});

			var snv = GravityRD.Cookie.getSessionNameValues();
			Object.keys(snv).forEach(function(k) {
				GravityRD.Log.debug("Loading session namevalue: " + k, snv[k]);
				GravityRD.Core.addGlobalNameValue(k, snv[k],true, false);
			});


			var config = GravityRD.Core.getConfig();

			if (config["disabled"] === true) {
				throw new Error(GravityRD.Log.errorMessages.GR029);
			}

			// Needs to be called, because its side effect is handling the optout state
			GravityRD.Cookie.getGeneratedCookie();

			if (GravityRD.CustomConfig !== undefined) {
				GravityRD.CustomConfig.init();
			}

			GravityRD.Log.debug("Customconfig initialized");

			GravityRD.Cookie.initSessionCookie();
			GravityRD.Cookie.initPageCookie();

			if(GravityRD.Core.locationSearch.liveeditor){
				var script = document.createElement('script');
				script.src = GravityRD.Core.locationSearch.isDev
					? "https://gravity-dev-assets.oss-eu-central-1.aliyuncs.com/liveeditorStandaloneV2.js"
					: window.location.protocol + "//" + GravityRD.Core.config.targetServer +
					"/assets/d2sme/liveeditorStandaloneV2.js";
				script.type = 'text/javascript';
				script.async = true;
				document.getElementsByTagName("head")[0].appendChild(script);
			}

			this.processInitialArray();
			this.installPushProcessor();
			GravityRD.Log.debug("Worker started");

			return true;
		}
	}
	GravityRD.Worker = new Worker();

})(GravityRD);

    }catch (e) {
        console.error(e);
        var message = e instanceof Error ? e.message : e;
        var CHUNK_SIZE = 1600;
        for (var p = 0; p + CHUNK_SIZE < message.length; p += CHUNK_SIZE) {
            var config = GravityRD.Core.getConfig();
            var ep = GravityRD.Core.Request.getEndpoint();
            GravityRD.Core.Request.scriptTagRequest(ep, "ex=CUSTOM&ec=" + encodeURIComponent(message.slice(p, p + CHUNK_SIZE)));
        }
        GravityRD.Base.onUsageError(msg);
    }

    var conf = {
        
            debug: true,
            mode: 'DEVELOP',
        
        persistUserId: true,
    }

    if( document.readyState !== 'loading' ) {
        GravityRD.Base.start(conf);
    } else {
        document.addEventListener('DOMContentLoaded', function () {
            GravityRD.Base.start(conf);
        });
    }

    
        window.GR = GravityRD;
    

})();